// ============================================================================
// JAMB Question Bank — Novel
// Auto-split from QB.js for better code organisation
// ============================================================================

export const QB_NOVEL = [

    {
      yr: 2024,
      q: "In 'The Lekki Headmaster', what was the 'Point of No Return' in Badagry intended to symbolize for Mr. Bepo?",
      o: ["The finality of death", "The loss of African identity through migration", "A popular tourist destination", "The beginning of a new life"],
      a: 1,
      e: "Bepo views the 'Japa' trend as a modern, voluntary form of the slave trade he saw in Badagry.",
      full: "While standing at the Gberefu Island, Bepo reflects on how his ancestors were forced into ships, whereas modern Nigerians are desperately paying 'Visa fees' to enter the same system. This is a core thematic comparison in the novel.",
      h: "Does he see it as 'Freedom' or as a 'Sacrifice of his roots'?"
    },
    {
      yr: 2024,
      q: "Why did Mr. Bepo refuse to give his speech and instead cry at the Monday assembly?",
      o: ["He was mourning a dead student", "He was overwhelmed by the 'Japa' pressure from his family", "He had just been sacked by Mrs. Gloss", "He was angry at the teachers"],
      a: 1,
      e: "His wife Seri's constant pressure for him to move to the UK reached a breaking point during the assembly.",
      full: "After Ikenna Egbu's speech about Jos, Bepo realized how much he loved his country and his job, but the financial pressure from his family in London (who earn in Pounds) caused his emotional collapse.",
      h: "Is his pain caused by 'School problems' or 'Family/Migration pressure'?"
    },
    {
      yr: 2024,
      q: "What is the specific nickname given to Mr. Adewale Bepo by his colleagues?",
      o: ["The King of Lekki", "The Village Headmaster", "The Lekki Headmaster", "The Stardom Principal"],
      a: 2,
      e: "He is called 'The Lekki Headmaster' because he mimics characters from the old TV show.",
      full: "The Fine Arts teacher, Mr. Audu, popularized the name because Bepo often used humor and mimicry (imitating characters like 'King Oloja') to settle disputes or teach lessons in the high-brow Lekki school.",
      h: "It's the title of the book—what is his specific nickname?"
    },
    {
      yr: 2024,
      q: "How much does Mr. Bepo earn as a monthly salary at Stardom Schools?",
      o: ["N100,000", "N400,000", "N850,000", "N1.2 Million"],
      a: 1,
      e: "Bepo's salary is N400,000, which is the source of his wife's dissatisfaction.",
      full: "Seri, who is a nurse in the UK earning £3,600 (about N1.7 million at the time), mocks his N400,000 salary as being 'worthless' when converted to foreign currency, driving the conflict of the book.",
      h: "Is it closer to 'Four hundred thousand' or 'One million'?"
    },
    {
      yr: 2025,
      q: "Which student delivered the moving talk about the rock formations in Jos?",
      o: ["Banky", "Tosh", "Ikenna Egbu", "Angel"],
      a: 2,
      e: "Ikenna Egbu, an SSS 1 student, gave the poetic description of the Jos excursion.",
      full: "Ikenna described the 'artistic layers of rocks' in Jos and the cool weather of Plateau State. His passion for Nigeria's beauty was the trigger that made Bepo realize why he didn't want to 'Japa'.",
      h: "Which boy talked about 'Shere Hills' and 'Lamigo Dam'?"
    },
    {
      yr: 2024,
      q: "Who is the Managing Director (MD) of Stardom Schools?",
      o: ["Mrs. Grace Apeh", "Mrs. Ibidun Gloss", "Mrs. Seri Bepo", "Mrs. Titi"],
      a: 1,
      e: "Mrs. Ibidun Gloss is the owner and daughter of the late Chief David Aje.",
      full: "Mrs. Gloss is a strict businesswoman who focuses on results. She rewards the 90% WASSCE success but is also known for sacking her own cousin, Funsho Daniels, for incompetence.",
      h: "Think of the name 'Glossy'—who is the boss?"
    },
    {
      yr: 2024,
      q: "What was the 'Invention Club' at Stardom Schools trying to create?",
      o: ["A solar-powered generator", "Mobile phones from recycled e-waste", "A new social media app", "An electric car"],
      a: 1,
      e: "The club was building functional mobile phones from discarded electronic waste.",
      full: "The Invention Club symbolizes Bepo's belief in Nigerian youth. He feels that if he leaves for the UK, these talented children will lose their mentor and their chance to innovate for Nigeria.",
      h: "Were they 'inventing' gadgets or just 'studying' electronics?"
    },
    {
      yr: 2025,
      q: "Why did Mr. Bepo leave his former place of work, Beesway Group of Schools?",
      o: ["He was offered a higher salary at Stardom", "He discovered the owner was involved in ritual sacrifices", "He was sacked for insubordination", "He wanted to relocate to Lekki"],
      a: 1,
      e: "Bepo witnessed the slaughtering of a cow as a 'ritual' to make the school grow.",
      full: "This flashback establishes Bepo’s high moral integrity. He refused to be part of a system that used 'charms' or unethical means to achieve success, leading him to join Stardom Schools instead.",
      h: "Did he leave because of 'Money' or because of 'Moral/Religious' reasons?"
    },
    {
      yr: 2024,
      q: "Who is the Vice Principal (VP) of Stardom Schools?",
      o: ["Mrs. Titi", "Mrs. Grace Apeh", "Mr. Audu", "Mr. Justus Anabel"],
      a: 1,
      e: "Mrs. Grace Apeh is the Principal's right-hand woman and stabilizer of the school.",
      full: "Mrs. Apeh is the first person to comfort Bepo when he cries. She represents the loyal and professional Nigerian educator who keeps the system running despite the challenges.",
      h: "Which 'Grace' is second-in-command to Mr. Bepo?"
    },
    {
      yr: 2025,
      q: "What is the primary profession of Bepo's wife, Seri, in London?",
      o: ["Teacher", "Cleaner", "Nurse", "Sales Agent"],
      a: 2,
      e: "Seri works as a nurse in the UK, earning £3,600 monthly.",
      full: "Seri's career success in the UK is the main reason she pressures Bepo to join her. She believes that as a Principal, he is 'wasting' his time in Nigeria when he could be making more money abroad.",
      h: "Does she work in a 'Hospital' or a 'School' in the UK?"
    },
    {
      yr: 2024,
      q: "The rivalry between students Banky and Tosh in the novel was a reflection of:",
      o: ["A sports competition", "A court case between their parents", "A fight over a girl", "Their tribal differences"],
      a: 1,
      e: "Their parents were involved in a serious legal battle, which the children brought to school.",
      full: "Bepo had to manage the tension between these two students, showing how adult legal and social conflicts in Lekki elite society filter down to the children in the classroom.",
      h: "Was the 'war' between the boys or between their 'Moms and Dads'?"
    },
    {
      yr: 2024,
      q: "In 'The Lekki Headmaster', what was the cash reward given to SSS 3 teachers for the WASSCE results?",
      o: ["N10,000", "N20,000", "N50,000", "N100,000"],
      a: 1,
      e: "The MD gave N20,000 to teachers whose students performed well in the exams.",
      full: "Mrs. Gloss used these financial incentives (along with wine and snacks) to motivate the staff. This highlights the 'performance-based' culture of private schools in the novel.",
      h: "Is it 'Twenty thousand' or 'Fifty thousand'?"
    },
    {
      yr: 2025,
      q: "What is the age of Mr. Adewale Bepo in the novel?",
      o: ["45 years", "51 years", "60 years", "55 years"],
      a: 1,
      e: "Mr. Bepo is 51 years old.",
      full: "Being 51 makes his decision harder. He feels he is too old to start as a 'carer' or 'assistant' in London, but his wife thinks he is at the perfect age to 'secure their future' abroad.",
      h: "Is he 'Fifty-one' or 'Sixty-one'?"
    },
    {
      yr: 2024,
      q: "Who is the Physics teacher that is also a Pastor?",
      o: ["Mr. Audu", "Mr. Ope Wande", "Mr. Oyelana", "Mr. Fafore"],
      a: 1,
      e: "Mr. Ope Wande combines his role as a science teacher with his pastoral calling.",
      full: "Pastor Ope Wande is one of the staff members who looks up to Bepo. He represents the intersection of faith, discipline, and education in the Nigerian setting.",
      h: "His name sounds like 'Open'—who is he?"
    },
    {
      yr: 2024,
      q: "What is the final decision made by Mr. Bepo at the end of the novel?",
      o: ["He moves to London and joins his family", "He stays in Nigeria to continue his work as an educator", "He resigns and moves to his village", "He starts his own school in Lekki"],
      a: 1,
      e: "Bepo chooses patriotism and his noble calling over the financial lure of migration.",
      full: "The climax of the book shows Bepo rejecting the 'Point of No Return' and choosing to stay and build the future of Nigerian children through Stardom Schools and the Invention Club.",
      h: "Does he end up in 'London' or 'Lagos'?"
    },
    {
      yr: 2024,
      q: "Who is the teacher that frequently cracks jokes and mimics characters alongside Mr. Bepo?",
      o: ["Mr. Justus Anabel", "Mr. Audu", "Mr. Ope Wande", "Mr. Oyelana"],
      a: 1,
      e: "Mr. Audu, the Fine Arts teacher, is Bepo's closest 'humor partner' on the staff.",
      full: "Mr. Audu is the one who popularized the 'Lekki Headmaster' nickname. He represents the lively, artistic spirit of the school and is a key witness to Bepo's emotional struggles.",
      h: "Does the teacher's name start with 'A' or 'J'?"
    },
    {
      yr: 2024,
      q: "In the novel, what is the name of the school's secondary section?",
      o: ["Stardom Kiddies", "Stardom Schools", "Lekki International", "Aje Memorial"],
      a: 1,
      e: "While the primary is 'Stardom Kiddies', the secondary is simply 'Stardom Schools'.",
      full: "This distinction is important because Bepo moved from being the Headmaster of 'Kiddies' to being the Principal of the 'Schools'. JAMB often tests these specific naming conventions.",
      h: "Is it 'Kiddies' or just 'Schools' for the senior students?"
    },
    {
      yr: 2024,
      q: "What was the name of the SSS 3 student who won a prestigious prize mentioned in the text?",
      o: ["Angel", "Ikenna", "Tosh", "Banky"],
      a: 0,
      e: "Angel is recognized as a high-performing student in the senior class.",
      full: "Angel’s success, along with the 90% WASSCE pass rate, is used by the author to show that Stardom Schools is a center of excellence that Bepo has worked hard to build.",
      h: "Think of a 'Heavenly' name for a bright student."
    },
    {
      yr: 2025,
      q: "Why did Mrs. Ibidun Gloss sack her own cousin, Funsho Daniels?",
      o: ["He stole school fees", "He was incompetent and lazy", "He insulted Mr. Bepo", "He wanted to start a rival school"],
      a: 1,
      e: "Mrs. Gloss prioritized the school’s standards over her family relationship.",
      full: "The sacking of Funsho Daniels serves as a warning to all staff, including Bepo, that the MD (Mrs. Gloss) is a strict capitalist who only cares about the 'Stardom' brand's success.",
      h: "Was he 'Good at his job' or 'Bad at his job'?"
    },
    {
      yr: 2024,
      q: "Which specific location in Lagos is described as the 'Heart of trade and proverbs'?",
      o: ["Balogun", "Oshodi", "Oyingbo", "Mushin"],
      a: 2,
      e: "Oyingbo Market is used to represent the authentic, vibrant culture of Lagos.",
      full: "Bepo’s love for the Oyingbo market symbolizes his connection to his roots. The author uses this setting to show what Bepo would miss if he moved to the 'quiet' and 'isolated' life in London.",
      h: "Which 'O' market is famous for food and culture in Lagos?"
    },
    {
      yr: 2025,
      q: "What is the name of Bepo's eldest daughter in the UK?",
      o: ["Nike", "Kike", "Sade", "Titi"],
      a: 0,
      e: "Nike is the elder daughter, followed by Kike.",
      full: "The names Nike and Kike are mentioned frequently during Bepo’s phone calls with his family. They are the 'voice of the UK' in his ear, constantly telling him to leave Nigeria.",
      h: "Which name sounds like a famous sportswear brand?"
    },
    {
      yr: 2024,
      q: "Who is the teacher that concludes the Monday assembly after Bepo is led away?",
      o: ["Mrs. Grace Apeh", "Mr. Justus Anabel", "Mr. Audu", "Mr. Ope Wande"],
      a: 1,
      e: "Justus Anabel took over the microphone to maintain order.",
      full: "While the VP (Mrs. Apeh) followed Bepo to check on him, she signaled Mr. Justus Anabel to wrap up the proceedings so the students wouldn't continue to stare at the crying Principal.",
      h: "Was it a 'Male' teacher or a 'Female' teacher who finished the assembly?"
    },
    {
      yr: 2024,
      q: "What physical reaction did the students have to Bepo's breakdown?",
      o: ["They laughed at him", "They were shocked and stayed silent", "They started crying too", "They booed him"],
      a: 1,
      e: "The assembly was described as falling into a 'deadly silence' of shock.",
      full: "Because Bepo was seen as a 'Pillar of Sanity' and a strong leader, seeing him sob like a child was a traumatic and confusing moment for the entire school community.",
      h: "Were the students 'Noisy' or 'Deadly Quiet'?"
    },
    {
      yr: 2025,
      q: "In 'The Lekki Headmaster', who is the father of Mrs. Ibidun Gloss?",
      o: ["Chief David Aje", "Mr. Adewale Bepo", "Mr. Funsho", "Chief Okon"],
      a: 0,
      e: "The late Chief David Aje was the wealthy man who founded the family's fortune.",
      full: "Mrs. Gloss inherited her wealth and the school land from her father. The name 'Aje' (meaning wealth/money in Yoruba) is a symbolic name for the source of the school's capital.",
      h: "Is his name 'Chief David Aje' or 'Chief David Bepo'?"
    },
    {
      yr: 2024,
      q: "The 'Invention Club' aimed to convert 'e-waste' into:",
      o: ["Radio sets", "Mobile phones", "Laptops", "Television screens"],
      a: 1,
      e: "They were specifically working on creating functional mobile phones.",
      full: "This project is the ultimate symbol of Bepo's hope for Nigeria's future. He believes that if students can build phones from trash, they can build a nation from its current struggles.",
      h: "Did they make 'Computers' or 'Handheld Phones'?"
    },
    {
      yr: 2024,
      q: "Which character is the school nurse?",
      o: ["Mrs. Grace", "Mrs. Titi", "Mrs. Beke", "Mrs. Seri"],
      a: 1,
      e: "Mrs. Titi is the school nurse who provided first aid to Bepo's emotions.",
      full: "Mrs. Titi is a minor but significant character who represents the care system in the school. She is the one who physically checks on Bepo after his collapse.",
      h: "Does her name start with 'T' or 'G'?"
    },
    {
      yr: 2025,
      q: "What is the primary literary device used in comparing 'Japa' to the 'Slave Trade'?",
      o: ["Hyperbole", "Metaphor/Simile", "Oxymoron", "Onomatopoeia"],
      a: 1,
      e: "The author uses a direct comparison (metaphor) between modern migration and historical slavery.",
      full: "By using the 'Point of No Return' as a setting, the author forces the reader to see the 'Chains' of modern economic migration. This is the most important literary technique in the book.",
      h: "Is it a 'comparison' or an 'exaggeration'?"
    },
    {
      yr: 2024,
      q: "Who is the Physics teacher who respects Bepo's integrity?",
      o: ["Mr. Audu", "Mr. Ope Wande", "Mr. Oyelana", "Mr. Fafore"],
      a: 1,
      e: "Mr. Ope Wande is the Physics teacher and also a Pastor.",
      full: "Mr. Ope Wande is shown as a man of science and faith. He is one of the loyal staff members who would be 'orphaned' if Bepo decided to leave for the UK.",
      h: "Which teacher has a name like 'Open'?"
    },
    {
      yr: 2024,
      q: "What does Mrs. Gloss provide along with cash to reward the SSS 3 teachers?",
      o: ["New cars", "Bottles of wine and snacks", "Promotion letters", "Holiday tickets"],
      a: 1,
      e: "She provided wine, snacks, and cash (N20,000–N30,000) as incentives.",
      full: "This highlights the 'work hard, play hard' culture of high-end private schools in Lekki. It also shows that Mrs. Gloss knows how to keep her 'best assets' (the teachers) happy.",
      h: "Was it 'Cars' or 'Wine and Snacks'?"
    },
    {
      yr: 2024,
      q: "What is the final word on Bepo's character at the end of the novel?",
      o: ["He is a coward who ran away", "He is a patriot who stayed to build", "He is a greedy man seeking wealth", "He is a failure as a principal"],
      a: 1,
      e: "The novel ends by portraying Bepo as a symbol of national hope and patriotism.",
      full: "By choosing Stardom Schools over the UK, Bepo proves that the 'noble calling' of education is worth more than a salary in Pounds. He remains 'The Lekki Headmaster' in heart and soul.",
      h: "Does he 'Stay' or 'Go'?"
    },
    {
      yr: 2024,
      q: "Who is the teacher that frequently cracks jokes and mimics characters alongside Mr. Bepo?",
      o: ["Mr. Justus Anabel", "Mr. Audu", "Mr. Ope Wande", "Mr. Oyelana"],
      a: 1,
      e: "Mr. Audu, the Fine Arts teacher, is Bepo's closest 'humor partner' on the staff.",
      full: "Mr. Audu is the one who popularized the 'Lekki Headmaster' nickname. He represents the lively, artistic spirit of the school and is a key witness to Bepo's emotional struggles.",
      h: "Does the teacher's name start with 'A' or 'J'?"
    },
    {
      yr: 2024,
      q: "In the novel, what is the name of the school's secondary section?",
      o: ["Stardom Kiddies", "Stardom Schools", "Lekki International", "Aje Memorial"],
      a: 1,
      e: "While the primary is 'Stardom Kiddies', the secondary is simply 'Stardom Schools'.",
      full: "This distinction is important because Bepo moved from being the Headmaster of 'Kiddies' to being the Principal of the 'Schools'. JAMB often tests these specific naming conventions.",
      h: "Is it 'Kiddies' or just 'Schools' for the senior students?"
    },
    {
      yr: 2024,
      q: "What was the name of the SSS 3 student who won a prestigious prize mentioned in the text?",
      o: ["Angel", "Ikenna", "Tosh", "Banky"],
      a: 0,
      e: "Angel is recognized as a high-performing student in the senior class.",
      full: "Angel’s success, along with the 90% WASSCE pass rate, is used by the author to show that Stardom Schools is a center of excellence that Bepo has worked hard to build.",
      h: "Think of a 'Heavenly' name for a bright student."
    },
    {
      yr: 2025,
      q: "Why did Mrs. Ibidun Gloss sack her own cousin, Funsho Daniels?",
      o: ["He stole school fees", "He was incompetent and lazy", "He insulted Mr. Bepo", "He wanted to start a rival school"],
      a: 1,
      e: "Mrs. Gloss prioritized the school’s standards over her family relationship.",
      full: "The sacking of Funsho Daniels serves as a warning to all staff, including Bepo, that the MD (Mrs. Gloss) is a strict capitalist who only cares about the 'Stardom' brand's success.",
      h: "Was he 'Good at his job' or 'Bad at his job'?"
    },
    {
      yr: 2024,
      q: "Which specific location in Lagos is described as the 'Heart of trade and proverbs'?",
      o: ["Balogun", "Oshodi", "Oyingbo", "Mushin"],
      a: 2,
      e: "Oyingbo Market is used to represent the authentic, vibrant culture of Lagos.",
      full: "Bepo’s love for the Oyingbo market symbolizes his connection to his roots. The author uses this setting to show what Bepo would miss if he moved to the 'quiet' and 'isolated' life in London.",
      h: "Which 'O' market is famous for food and culture in Lagos?"
    },
    {
      yr: 2025,
      q: "What is the name of Bepo's eldest daughter in the UK?",
      o: ["Nike", "Kike", "Sade", "Titi"],
      a: 0,
      e: "Nike is the elder daughter, followed by Kike.",
      full: "The names Nike and Kike are mentioned frequently during Bepo’s phone calls with his family. They are the 'voice of the UK' in his ear, constantly telling him to leave Nigeria.",
      h: "Which name sounds like a famous sportswear brand?"
    },
    {
      yr: 2024,
      q: "Who is the teacher that concludes the Monday assembly after Bepo is led away?",
      o: ["Mrs. Grace Apeh", "Mr. Justus Anabel", "Mr. Audu", "Mr. Ope Wande"],
      a: 1,
      e: "Justus Anabel took over the microphone to maintain order.",
      full: "While the VP (Mrs. Apeh) followed Bepo to check on him, she signaled Mr. Justus Anabel to wrap up the proceedings so the students wouldn't continue to stare at the crying Principal.",
      h: "Was it a 'Male' teacher or a 'Female' teacher who finished the assembly?"
    },
    {
      yr: 2024,
      q: "What physical reaction did the students have to Bepo's breakdown?",
      o: ["They laughed at him", "They were shocked and stayed silent", "They started crying too", "They booed him"],
      a: 1,
      e: "The assembly was described as falling into a 'deadly silence' of shock.",
      full: "Because Bepo was seen as a 'Pillar of Sanity' and a strong leader, seeing him sob like a child was a traumatic and confusing moment for the entire school community.",
      h: "Were the students 'Noisy' or 'Deadly Quiet'?"
    },
    {
      yr: 2025,
      q: "In 'The Lekki Headmaster', who is the father of Mrs. Ibidun Gloss?",
      o: ["Chief David Aje", "Mr. Adewale Bepo", "Mr. Funsho", "Chief Okon"],
      a: 0,
      e: "The late Chief David Aje was the wealthy man who founded the family's fortune.",
      full: "Mrs. Gloss inherited her wealth and the school land from her father. The name 'Aje' (meaning wealth/money in Yoruba) is a symbolic name for the source of the school's capital.",
      h: "Is his name 'Chief David Aje' or 'Chief David Bepo'?"
    },
    {
      yr: 2024,
      q: "The 'Invention Club' aimed to convert 'e-waste' into:",
      o: ["Radio sets", "Mobile phones", "Laptops", "Television screens"],
      a: 1,
      e: "They were specifically working on creating functional mobile phones.",
      full: "This project is the ultimate symbol of Bepo's hope for Nigeria's future. He believes that if students can build phones from trash, they can build a nation from its current struggles.",
      h: "Did they make 'Computers' or 'Handheld Phones'?"
    },
    {
      yr: 2024,
      q: "Which character is the school nurse?",
      o: ["Mrs. Grace", "Mrs. Titi", "Mrs. Beke", "Mrs. Seri"],
      a: 1,
      e: "Mrs. Titi is the school nurse who provided first aid to Bepo's emotions.",
      full: "Mrs. Titi is a minor but significant character who represents the care system in the school. She is the one who physically checks on Bepo after his collapse.",
      h: "Does her name start with 'T' or 'G'?"
    },
    {
      yr: 2025,
      q: "What is the primary literary device used in comparing 'Japa' to the 'Slave Trade'?",
      o: ["Hyperbole", "Metaphor/Simile", "Oxymoron", "Onomatopoeia"],
      a: 1,
      e: "The author uses a direct comparison (metaphor) between modern migration and historical slavery.",
      full: "By using the 'Point of No Return' as a setting, the author forces the reader to see the 'Chains' of modern economic migration. This is the most important literary technique in the book.",
      h: "Is it a 'comparison' or an 'exaggeration'?"
    },
    {
      yr: 2024,
      q: "Who is the Physics teacher who respects Bepo's integrity?",
      o: ["Mr. Audu", "Mr. Ope Wande", "Mr. Oyelana", "Mr. Fafore"],
      a: 1,
      e: "Mr. Ope Wande is the Physics teacher and also a Pastor.",
      full: "Mr. Ope Wande is shown as a man of science and faith. He is one of the loyal staff members who would be 'orphaned' if Bepo decided to leave for the UK.",
      h: "Which teacher has a name like 'Open'?"
    },
    {
      yr: 2024,
      q: "What does Mrs. Gloss provide along with cash to reward the SSS 3 teachers?",
      o: ["New cars", "Bottles of wine and snacks", "Promotion letters", "Holiday tickets"],
      a: 1,
      e: "She provided wine, snacks, and cash (N20,000–N30,000) as incentives.",
      full: "This highlights the 'work hard, play hard' culture of high-end private schools in Lekki. It also shows that Mrs. Gloss knows how to keep her 'best assets' (the teachers) happy.",
      h: "Was it 'Cars' or 'Wine and Snacks'?"
    },
    {
      yr: 2024,
      q: "What is the final word on Bepo's character at the end of the novel?",
      o: ["He is a coward who ran away", "He is a patriot who stayed to build", "He is a greedy man seeking wealth", "He is a failure as a principal"],
      a: 1,
      e: "The novel ends by portraying Bepo as a symbol of national hope and patriotism.",
      full: "By choosing Stardom Schools over the UK, Bepo proves that the 'noble calling' of education is worth more than a salary in Pounds. He remains 'The Lekki Headmaster' in heart and soul.",
      h: "Does he 'Stay' or 'Go'?"
    },

    
  {
    yr: 2025,
    q: 'What happened on the Monday after Bepo\'s departure from Stardom Schools?',
    o: [
      'Students refused to enter the school',
      'Students mourned his absence',
      'Mrs. Gloss announced a new principal',
      'Bepo returned unexpectedly',
    ],
    a: 3,
    e: 'Bepo returned to Stardom Schools unexpectedly on the Monday after his departure, unable to stay away from his students and mission.',
    full: 'After his emotional farewell, Bepo initially left for the UK. However, his deep connection to Stardom Schools — its students, mission, and cultural programmes — made it impossible for him to go through with leaving. He turned back and returned to the school on the very Monday after his departure, shocking and overjoying the entire school community.',
    h: 'Bepo\'s departure didn\'t last long — what happened just days after he left?',
  },
  {
    yr: 2025,
    q: 'What did the students chant when Bepo returned to Stardom Schools?',
    o: [
      '"We\'re Stars, we\'re always winning!"',
      '"Welcome back, Principal!"',
      '"Thank you, Bepo!"',
      '"Our heart is here!"',
    ],
    a: 0,
    e: 'The students chanted their school\'s victory song — "We\'re Stars, we\'re always winning!" — as a jubilant celebration of Bepo\'s unexpected return.',
    full: 'Bepo\'s return was met with overwhelming celebration. The students, who had been emotionally downcast since his farewell, erupted in joyful cheers and sang Stardom Schools\' signature song: "We\'re Stars, we\'re always winning!" This moment encapsulated the bond between Bepo and his students and the spirit of unity he had built at the school.',
    h: 'Stardom Schools had a signature chant — what was it, and when did students sing it at Bepo\'s return?',
  },
  {
    yr: 2025,
    q: 'Why did Bepo decide to return to Stardom Schools after his farewell?',
    o: [
      'He missed his students and mission',
      'His flight was cancelled',
      'His passport was invalid',
      'He received a call from Mrs. Gloss',
    ],
    a: 0,
    e: 'Bepo returned because his heart and mission were inseparably linked to Stardom Schools and its students. No career opportunity abroad could outweigh that calling.',
    full: 'Bepo\'s return was not forced by any external event — his flight was not cancelled, his passport was not invalid, and nobody called him back. It was an entirely internal decision driven by his love for his students and his sense of purpose at Stardom Schools. The novel uses this moment to affirm its central message: that true fulfillment comes from living out one\'s vocation.',
    h: 'What internally drove Bepo to turn back — was it a logistics problem or something deeper?',
  },
  {
    yr: 2025,
    q: 'What was the symbolic significance of Bepo\'s return to Stardom?',
    o: [
      'Dedication to his duty',
      'Nostalgia for Nigeria',
      'Rejection of migration',
      'Triumph of love over ambition',
    ],
    a: 0,
    e: 'Bepo\'s return symbolises his unwavering dedication to duty — his vocation as an educator took precedence over personal gain or family pressure.',
    full: 'While Bepo\'s return could be interpreted as nostalgia (B), rejection of migration (C), or triumph of love (D), the novel\'s primary symbolic message is one of duty and dedication. Bepo is portrayed as a man who could not abandon his calling. The final scenes reinforce that great educators are defined not by opportunity but by commitment — he chose to stay because his mission at Stardom was his purpose.',
    h: 'Among nostalgia, rejection of migration, or dedication to duty — which best captures why Bepo returned?',
  },
  {
    yr: 2025,
    q: 'What song did the students sing as they celebrated Bepo\'s return to Stardom?',
    o: [
      'The national anthem',
      'Stardom\'s victory song',
      'The farewell song',
      'A cultural hymn',
    ],
    a: 1,
    e: 'Students sang Stardom\'s victory song — the school\'s signature anthem — to celebrate Bepo\'s joyful return.',
    full: 'Stardom Schools had a distinctive victory song that was central to its identity and culture: "We\'re Stars, we\'re Stars of Stardom!" This song was sung when the students welcomed Bepo back, transforming what had been a farewell into a triumphant reunion. The song embodies the school spirit Bepo himself had nurtured.',
    h: 'What school-specific song did students burst into when Bepo walked back through the gates?',
  },

  // ── Japa Syndrome (Q56–60) ────────────────────────────────────────────────
  {
    yr: 2025,
    q: 'What does the term "Japa syndrome" imply in the novel?',
    o: [
      'Leaving Nigeria for greener pastures',
      'Escaping responsibilities',
      'Returning home after migration',
      'Celebrating cultural heritage',
    ],
    a: 0,
    e: '"Japa" is Nigerian slang for fleeing or running away — "Japa syndrome" refers to the widespread trend of Nigerians emigrating abroad in search of better opportunities.',
    full: '"Japa" (from Yoruba — to run) became popular Nigerian slang for emigrating, especially to the UK, USA, or Canada. In the novel, "Japa syndrome" is used to describe the mass exodus of skilled Nigerians, including teachers, doctors, and professionals, who leave the country due to poor infrastructure, bad governance, and lack of opportunities. Bepo himself is tempted by this trend but ultimately resists it.',
    h: '"Japa" is Yoruba slang for running away — what does "Japa syndrome" describe in the novel\'s context?',
  },
  {
    yr: 2025,
    q: 'What lesson does the novel teach about migration?',
    o: [
      'Migration should always be the last option',
      'Migration brings mixed blessings and challenges',
      'Migration guarantees success',
      'Migration is a betrayal of one\'s roots',
    ],
    a: 1,
    e: 'The novel does not condemn migration outright but presents it as complex — it brings opportunity but also emotional, cultural, and social costs.',
    full: 'The novel takes a nuanced view of migration. While it criticises the brain drain caused by mass emigration (Japa syndrome), it does not portray migration as inherently wrong or as a betrayal of roots. Through Bepo\'s internal conflict, it shows that migration is deeply personal — it brings genuine opportunities (his family was in the UK, he had a job lined up) but also costs (separation from his mission and students). The lesson: migration is not black and white; it brings mixed blessings.',
    h: 'The novel doesn\'t say migration is purely good or bad — what balanced view does it present?',
  },
  {
    yr: 2025,
    q: 'What was Bepo\'s emotional reflection during his dream at the airport?',
    o: [
      'The history of slavery',
      'His personal struggle with leaving home',
      'His fears about his future abroad',
      'All of the above',
    ],
    a: 3,
    e: 'Bepo\'s airport dream encompassed all three — the horrors of slavery he had taught his students, his personal guilt about abandoning his mission, and his anxieties about an uncertain future in the UK.',
    full: 'The airport dream sequence is one of the most symbolically rich moments in the novel. As Bepo sits in the airport, his subconscious weaves together multiple threads: the slave museum he had visited with students (historical slavery), his deep sense of guilt about abandoning Stardom Schools (personal struggle with leaving), and his uncertainty about what life in the UK would actually be like (fears about the future). The novel uses the dream to show that these three anxieties are interconnected in Bepo\'s psyche.',
    h: 'Bepo\'s airport dream was vivid and multi-layered — what elements did it contain?',
  },

  // ── Character Development (Q61–65) ────────────────────────────────────────
  {
    yr: 2025,
    q: 'What nickname did students and staff use for Bepo?',
    o: ['"The Principal"', '"Headmaster Bepo"', '"Principoo"', '"Mr. Adebowale"'],
    a: 2,
    e: 'Students and staff affectionately called Bepo "Principoo" — a playful blend of "Principal" that reflected their warmth and love for him.',
    full: '"Principoo" was the affectionate nickname given to Bepo by his students and staff at Stardom Schools. The name conveys both respect (acknowledging his position as principal) and warmth (the playful "-oo" suffix reflects the familial bond between Bepo and the school community). This nickname is one of the most memorable elements of Bepo\'s characterisation.',
    h: 'What playful, affectionate nickname did Stardom\'s community give their beloved principal?',
  },
  {
    yr: 2025,
    q: 'What was Bepo\'s relationship with Mrs. Ibidun Gloss?',
    o: [
      'She was his supervisor',
      'She was his rival',
      'She deeply respected and appreciated his contributions',
      'She criticised his decisions frequently',
    ],
    a: 2,
    e: 'Mrs. Ibidun Gloss deeply respected Bepo and appreciated his leadership. She was a supportive colleague who celebrated his contributions, including delivering a heartfelt speech at his farewell.',
    full: 'Mrs. Ibidun Gloss is one of the novel\'s key supporting characters. Rather than being Bepo\'s rival or superior, she is portrayed as someone who genuinely admired his dedication and leadership style. Her witty remarks and intelligent commentary complemented Bepo\'s visionary approach. At his farewell ceremony, she delivered a moving speech honouring his legacy — a testament to their mutual respect.',
    h: 'Was Mrs. Gloss a rival, supervisor, or supporter of Bepo? What does the novel show?',
  },
  {
    yr: 2025,
    q: 'Why did Bepo develop a special bond with Jide, his landlord\'s grandson?',
    o: [
      'He coached him in elocution and African history',
      'Jide reminded him of his own childhood',
      'Jide was the most disciplined child in the neighbourhood',
      'Jide often helped him with household chores',
    ],
    a: 0,
    e: 'Bepo mentored Jide by coaching him in elocution and teaching him African history — extending his educational mission beyond the walls of Stardom Schools into his personal community.',
    full: 'Bepo\'s mentorship of Jide illustrates how his dedication to education was not confined to the classroom. Living as a tenant in Jide\'s grandfather\'s house, Bepo noticed the young boy\'s potential and took it upon himself to coach him in elocution (public speaking) and African history. This relationship reflects the novel\'s theme that true educators impact everyone in their sphere, not just formal students.',
    h: 'What specific subjects did Bepo mentor Jide in, showing his commitment to education extended beyond school?',
  },
  {
    yr: 2025,
    q: 'What was the reaction of Bepo\'s landlord\'s family to his departure?',
    o: [
      'They were indifferent',
      'They threw a farewell party',
      'They drove him to the airport and blessed him',
      'They advised him to stay back',
    ],
    a: 2,
    e: 'Bepo\'s landlord\'s family drove him to the airport and gave him their blessings before he departed — a touching gesture showing the deep community bonds he had built.',
    full: 'Bepo\'s impact extended far beyond Stardom Schools into his personal neighbourhood. His landlord\'s family — with whom he had built a genuine relationship through mentoring young Jide — drove him to the airport as a send-off. This intimate act of blessing and farewell shows that Bepo was loved not just as a principal but as a community member and mentor figure.',
    h: 'How did Bepo\'s landlord\'s family express their affection when he was leaving for the UK?',
  },

  // ── Educational Initiatives (Q31–35 already in session, use Q31–35 gap) ──
  // ── Using fresh section questions 66–80 ────────────────────────────────────
  {
    yr: 2025,
    q: 'What constant reference to excursions and historical sites symbolises in the novel?',
    o: [
      'Bepo\'s passion for travel',
      'The importance of cultural education',
      'The school\'s focus on leisure activities',
      'Nigeria\'s rich tourism potential',
    ],
    a: 1,
    e: 'The recurring excursions symbolise Bepo\'s belief that cultural and historical education is essential for building identity, patriotism, and national consciousness among students.',
    full: 'Throughout the novel, Stardom Schools organises excursions to sites like the Badagry Slave Museum, the Point of No Return, and Ikogosi Warm Springs. These are not presented as leisure trips but as deliberate educational experiences. They reflect Bepo\'s pedagogical philosophy: that students must be physically connected to Nigeria\'s history and culture to truly understand themselves and their nation. The excursions thus symbolise the importance of experiential, cultural education.',
    h: 'Why did Bepo keep organising trips to historical sites rather than conventional classroom teaching alone?',
  },
  {
    yr: 2025,
    q: 'What does the novel suggest about corruption in Nigeria, through Bepo\'s experiences?',
    o: [
      'It portrays corruption as a minor issue',
      'It highlights systemic inefficiencies, such as in passport renewal',
      'It blames citizens for accepting corruption',
      'It suggests corruption is unique to Africa',
    ],
    a: 1,
    e: 'The novel critiques systemic corruption through Bepo\'s passport renewal ordeal — long queues, bribery, NIN validation failures — showing it as a structural problem embedded in Nigerian bureaucracy.',
    full: 'When Bepo attempts to renew his passport, he encounters the full weight of Nigerian bureaucracy: overcrowded offices, bribery demands, network failures during NIN validation, and the need to travel to Ibadan to avoid Lagos\' chaos. The novel uses these experiences not to blame individual citizens but to expose systemic inefficiencies that frustrate even well-meaning, educated Nigerians. This is part of the broader critique of the conditions that drive the Japa syndrome.',
    h: 'How does the novel show corruption — through grand political events or everyday bureaucratic frustrations like passport renewal?',
  },
  {
    yr: 2025,
    q: 'What advice did Bepo give students about achieving success?',
    o: [
      '"Work hard and stay in Nigeria."',
      '"Make the best use of your talents and time."',
      '"Travel abroad to seek greener pastures."',
      '"Focus solely on education."',
    ],
    a: 1,
    e: 'Bepo\'s advice centred on maximising one\'s talents and time — a universal message not tied to geography, emphasising personal excellence over location.',
    full: 'Bepo consistently avoided prescriptive advice about whether students should stay in Nigeria or travel abroad. His counsel was more universal: make the best use of your talents and time. This reflects his belief in education as a tool for empowerment regardless of circumstances — a student who maximises their potential can succeed anywhere. It also subtly critiques those who migrate without purpose or preparation.',
    h: 'Bepo\'s advice to students was about maximising what — their location, their connections, or their talents and time?',
  },

  // ── Closing Events (Q81–85) ───────────────────────────────────────────────
  {
    yr: 2025,
    q: 'What song did the students sing at the end of the novel?',
    o: [
      '"We Shall Overcome"',
      '"We\'re Stars, we\'re Stars of Stardom!"',
      '"The Principal\'s Anthem"',
      '"Victory Is Ours"',
    ],
    a: 1,
    e: '"We\'re Stars, we\'re Stars of Stardom!" is Stardom Schools\' signature song, sung at the novel\'s climax when Bepo returns — a moment of collective joy and celebration.',
    full: 'The song "We\'re Stars, we\'re Stars of Stardom!" serves as Stardom Schools\' anthem and appears at the novel\'s emotional climax when Bepo walks back through the school gates. It is a symbol of the school community\'s identity, unity, and pride — all values Bepo had instilled. The song transforms the ending from a sad farewell into a triumphant reunion.',
    h: 'What is Stardom Schools\' signature song that appears at the novel\'s emotional climax?',
  },
  {
    yr: 2025,
    q: 'What does the ending of the novel signify about Bepo\'s character?',
    o: [
      'His indecisiveness',
      'His commitment to his mission',
      'His desire for attention',
      'His fear of change',
    ],
    a: 1,
    e: 'Bepo\'s return from the airport and his decision to stay at Stardom signify his unshakeable commitment to his mission as an educator — the defining trait of his character.',
    full: 'The novel\'s ending could be read superficially as Bepo being indecisive (going, then coming back) or as seeking attention. However, the deeper reading — and the one the novel supports — is that Bepo\'s return is the ultimate expression of his character: a man whose purpose and identity are inseparable from his vocation as an educator. He doesn\'t return because he\'s afraid or weak; he returns because it\'s who he is.',
    h: 'Bepo\'s return could look like indecision, but what quality does the novel actually want readers to see?',
  },
  {
    yr: 2025,
    q: 'What did the MD\'s speech about Bepo emphasise?',
    o: [
      'His contribution to the growth of Stardom Schools',
      'His ability to inspire both students and staff',
      'His passion for education and culture',
      'All of the above',
    ],
    a: 3,
    e: 'The MD\'s speech was comprehensive — it honoured Bepo\'s contribution to Stardom\'s growth, his inspirational leadership, and his passion for education and culture, recognising all dimensions of his legacy.',
    full: 'The MD\'s farewell speech to Bepo was not confined to one aspect of his leadership. It celebrated his track record of growing Stardom Schools into a cultural and educational institution, his ability to inspire everyone from students to staff members, and his deep passion for education as a transformative force. The speech served as a formal institutional acknowledgement of Bepo\'s multi-faceted legacy.',
    h: 'Was the MD\'s speech narrow (about one quality) or broad (covering all of Bepo\'s contributions)?',
  },

  // ── Leadership (Q86–90) ───────────────────────────────────────────────────
  {
    yr: 2025,
    q: 'What leadership quality did Bepo most exemplify throughout the novel?',
    o: [
      'Strictness and discipline',
      'Compassion and dedication',
      'Innovation and risk-taking',
      'Assertiveness and dominance',
    ],
    a: 1,
    e: 'Bepo\'s defining leadership quality is compassion and dedication — he consistently puts the needs of his students and school above personal comfort or ambition.',
    full: 'While Bepo certainly maintained standards (suggesting some discipline), the novel does not portray him primarily as strict or assertive. What distinguishes him is his compassionate, student-centred approach to leadership combined with his unwavering dedication to the school\'s mission. He stays late, organises meaningful excursions, mentors students personally, and ultimately sacrifices a comfortable life abroad — all expressions of compassionate dedication.',
    h: 'Between strictness, compassion, innovation, and assertiveness — which quality most defines Bepo\'s leadership in the novel?',
  },
  {
    yr: 2025,
    q: 'What was one of Bepo\'s most notable contributions to Stardom Schools?',
    o: [
      'Organising excursions to historical sites',
      'Establishing a mentorship programme',
      'Hosting international exchange programmes',
      'Introducing modern technology in classrooms',
    ],
    a: 0,
    e: 'Organising excursions to historical sites like Badagry and Ikogosi Warm Springs was one of Bepo\'s signature contributions — it defined Stardom\'s identity as a culturally conscious institution.',
    full: 'While Bepo may have contributed to mentorship and modern learning, the novel specifically highlights his organisation of excursions to historical and cultural sites as a defining contribution. These trips to the Badagry Slave Museum, the Point of No Return, and Ikogosi Warm Springs became central to Stardom Schools\' educational identity. They were Bepo\'s way of teaching history, culture, and patriotism experientially rather than theoretically.',
    h: 'The novel specifically highlights which Bepo contribution as shaping Stardom\'s cultural educational identity?',
  },
  {
    yr: 2025,
    q: 'How did Bepo motivate his students to excel?',
    o: [
      'By setting strict academic standards',
      'By incorporating cultural and historical education into their learning',
      'By offering monetary rewards',
      'By emphasising competition among them',
    ],
    a: 1,
    e: 'Bepo motivated students by making learning meaningful — connecting academic content to Nigerian history, culture, and identity through excursions and cultural programmes.',
    full: 'Bepo\'s motivational approach was fundamentally experiential and cultural. Rather than relying on grades, fear, or prizes, he connected students to something larger than themselves — their heritage, their history, and their national identity. By visiting slave routes, watching canoe dances, and debating real Nigerian issues, students found intrinsic motivation rooted in a sense of purpose and belonging.',
    h: 'What was Bepo\'s approach to motivation — extrinsic rewards, fear, competition, or meaningful cultural connection?',
  },

  // ── Cultural and Historical Context (Q96–100) ─────────────────────────────
  {
    yr: 2025,
    q: 'How long did Bepo serve as the principal of Stardom Schools?',
    o: ['10 years', '15 years', '24 years', '30 years'],
    a: 2,
    e: 'Bepo served as principal of Stardom Schools for 24 years — a remarkable tenure that underscores his extraordinary dedication to the institution.',
    full: '24 years is a significant detail in the novel — it shows that Bepo\'s commitment to Stardom Schools was not brief or superficial but a lifelong vocation. Over nearly a quarter century, he shaped generations of students, built the school\'s cultural identity, and transformed it into the institution it became. His eventual decision to leave (and then return) after 24 years gives weight to both his sacrifice and his love for the school.',
    h: 'How many years did Bepo serve at Stardom — 10, 15, 24, or 30?',
  },
  {
    yr: 2025,
    q: 'What students chanted when Bepo returned to Stardom after his planned departure?',
    o: [
      '"Welcome back, Principoo!"',
      '"We\'re Stars, we\'re always winning!"',
      '"No one can replace Bepo!"',
      '"The heart of Stardom is here!"',
    ],
    a: 0,
    e: 'The students\' cry of "Welcome back, Principoo!" used his beloved nickname, making his return personally and emotionally resonant for Bepo.',
    full: 'When Bepo walked back into Stardom Schools on the Monday after his farewell, the students greeted him with "Welcome back, Principoo!" — using the affectionate nickname they had given him. The word "Principoo" packed both reverence and affection, and hearing it after an emotional separation made Bepo\'s return all the more poignant. This chant is distinct from the school\'s victory song, which they also sang.',
    h: 'The students used Bepo\'s special nickname when welcoming him back — what did they call out?',
  },
  {
    yr: 2025,
    q: 'What does Bepo\'s farewell ceremony\'s $10,000 gift symbolise?',
    o: [
      'Recognition of Bepo\'s impact',
      'Gratitude for his service',
      'A token of appreciation from the community',
      'All of the above',
    ],
    a: 3,
    e: 'The $10,000 farewell gift is multi-layered — it recognises Bepo\'s impact, expresses gratitude for 24 years of service, and represents the entire community\'s appreciation.',
    full: 'The $10,000 presented to Bepo at his farewell is not merely a financial gift. It is a symbolic gesture carrying multiple meanings: acknowledgement of the transformation he brought to Stardom Schools (recognition), genuine gratitude for 24 years of dedicated service (gratitude), and a collective gesture from the whole school community — students, staff, management (community appreciation). The size of the gift ($10,000) also signals how highly the institution valued him.',
    h: 'Was the $10,000 gift just about money, or does it carry symbolic meanings of recognition, gratitude, and community?',
  },

  // ── Japa (Q76–80) ─────────────────────────────────────────────────────────
  {
    yr: 2025,
    q: 'What does the novel suggest as the impact of migration on Nigerian society?',
    o: [
      'It creates a void in leadership and development',
      'It strengthens ties between Nigeria and the diaspora',
      'It fosters economic growth through remittances',
      'It allows Nigerians to access better opportunities',
    ],
    a: 0,
    e: 'The novel\'s primary critique of migration (Japa syndrome) is that it depletes Nigeria of its most skilled and dedicated people, creating a leadership and development vacuum.',
    full: 'While migration can bring remittances and diaspora connections, the novel is primarily concerned with what is LOST when Nigerians like Bepo leave: vision, dedication, cultural knowledge, and transformative leadership. When talented educators, doctors, and professionals emigrate en masse, institutions weaken, students lose mentors, and development stalls. Bepo\'s story dramatises this void — Stardom Schools would have lost its soul if he had left permanently.',
    h: 'What is the novel\'s main concern about what happens to Nigeria when its talented people emigrate?',
  },

  // ── Farewell Ceremony (Q131–135) ──────────────────────────────────────────
  {
    yr: 2025,
    q: 'What emotional moment most defined the farewell ceremony for Bepo?',
    o: [
      'The students\' canoe dance performance',
      'Mrs. Gloss\'s speech about his legacy',
      'The presentation of the $10,000 gift',
      'The unveiling of the farewell banner',
    ],
    a: 0,
    e: 'The canoe dance was the most emotionally charged moment — it moved Bepo to shout "Nooo!" and become visibly overwhelmed, as the dance connected to the deeper symbolism of slavery and his cultural roots.',
    full: 'While Mrs. Gloss\'s speech, the $10,000 gift, and the farewell banner all marked significant moments, it was the canoe dance that broke through Bepo\'s composure. The canoe dance symbolised both migration and the historical suffering of the transatlantic slave trade — themes close to Bepo\'s heart given his love of history and his own impending departure. When the students performed it, it triggered a deep emotional response: he shouted "Nooo!" and became overwhelmed with emotion.',
    h: 'Which single performance at Bepo\'s farewell reduced him to emotional outburst — the speeches, the dance, or the gift?',
  },
  {
    yr: 2025,
    q: 'What was the significance of the students\' chant during Bepo\'s return?',
    o: [
      'It showed their unity and loyalty to him',
      'It emphasised their disappointment in his absence',
      'It celebrated his influence on their lives',
      'Both A and C',
    ],
    a: 3,
    e: 'The chant simultaneously showed the students\' collective unity and loyalty to Bepo AND celebrated the profound influence he had had on their lives.',
    full: 'When students chanted their songs upon Bepo\'s return, the moment was layered. It showed their unity — they chanted together as one community (A). It also celebrated his influence — their songs and chants were themselves products of the school culture Bepo had built (C). Option B (disappointment in his absence) is not accurate — the chants were joyful, not reproachful. The correct answer is D: both A and C.',
    h: 'When students chanted upon Bepo\'s return — was it unity, celebration of his influence, or both?',
  },
  {
    yr: 2025,
    q: 'What did the farewell ceremony represent for Stardom Schools overall?',
    o: [
      'A celebration of cultural and academic growth',
      'The end of an era under Bepo\'s leadership',
      'A moment of reflection and gratitude',
      'All of the above',
    ],
    a: 3,
    e: 'The farewell ceremony was multifaceted — it celebrated 24 years of growth, marked the close of Bepo\'s era, and provided a space for collective gratitude and reflection.',
    full: 'Bepo\'s farewell was a rich, multi-dimensional event. The cultural performances (dances, songs) celebrated the cultural and academic growth he had fostered (A). The speeches, gifts, and banner acknowledged the end of his era as principal (B). And the emotional atmosphere — tears, heartfelt words, nostalgic songs — made it a moment of profound communal reflection and gratitude (C). All three dimensions were present simultaneously.',
    h: 'Was Bepo\'s farewell ceremony just a celebration, just a goodbye, or did it encompass all those dimensions at once?',
  },

  // ── Social and Political Commentary (Q106–110) ───────────────────────────
  {
    yr: 2025,
    q: 'What does Bepo\'s reflection on the Lagos-Ibadan Expressway highlight?',
    o: [
      'It is a symbol of progress',
      'It highlights infrastructural decay',
      'It represents hope for development',
      'Both B and C',
    ],
    a: 1,
    e: 'Bepo views the Lagos-Ibadan Expressway as evidence of Nigeria\'s infrastructural decay — its poor condition representing the wider failure of governance and development.',
    full: 'When Bepo travels to Ibadan to renew his passport (to avoid Lagos\' more chaotic immigration office), his experience on the Lagos-Ibadan Expressway becomes a commentary on Nigeria\'s infrastructure. Rather than seeing it as a symbol of progress or hope, Bepo notices its deterioration — potholes, traffic, poor maintenance — as a microcosm of Nigeria\'s development challenges. This experience deepens his understanding of why the Japa syndrome exists.',
    h: 'When Bepo drives on the Lagos-Ibadan Expressway, does he see hope and progress, or decay and failure?',
  },
  {
    yr: 2025,
    q: 'What does the novel teach about overcoming systemic challenges in Nigeria?',
    o: [
      'Perseverance and dedication are key',
      'Bribery is a necessary evil',
      'Avoiding the system is the best option',
      'Giving up is sometimes inevitable',
    ],
    a: 0,
    e: 'Through Bepo\'s struggles with passport renewal and bureaucracy, the novel consistently models perseverance and dedication as the way to navigate and overcome systemic obstacles.',
    full: 'The novel never endorses bribery (B) or avoidance (C) as solutions. Instead, through Bepo\'s character, it models perseverance: he travels to Ibadan when Lagos fails him, he persists through long queues, he refuses to be defeated by bureaucracy. The message is that systemic challenges are real and frustrating, but those who stay dedicated and keep pushing through — as Bepo does — are the ones who ultimately make a difference.',
    h: 'Bepo faces bureaucratic frustration — does the novel say to bribe, avoid, give up, or persevere?',
  },

  // ── Historical Figure (Q39) ───────────────────────────────────────────────
  {
    yr: 2025,
    q: 'What historical figure translated the Yoruba Bible, as referenced in the novel?',
    o: [
      'Rev. Samuel Ajayi Crowther',
      'Chief Didi Ogba',
      'J.P. Clark',
      'Rev. McGee',
    ],
    a: 0,
    e: 'Rev. Samuel Ajayi Crowther, the first African Anglican bishop, translated the Bible into Yoruba — a feat referenced in the novel during discussions of Nigerian heritage.',
    full: 'Rev. Samuel Ajayi Crowther (c.1809–1891) is one of Nigeria\'s most celebrated historical figures. Born Ajayi near Oyo, he was captured as a slave, freed by the British Navy, and became a pioneering missionary, linguist, and clergyman. He translated the Bible and Prayer Book into Yoruba and created a Yoruba grammar and dictionary. The novel references him as part of its broader engagement with Nigerian and Yoruba history, consistent with Bepo\'s passion for cultural education.',
    h: 'Which pioneering Nigerian bishop and linguist translated the Bible into Yoruba, referenced in the novel?',
  },

  // ── Cultural References (Q71–75) ──────────────────────────────────────────
  {
    yr: 2025,
    q: 'Which dances were performed during Bepo\'s farewell ceremony?',
    o: ['Bata dance', 'Atilogwu dance', 'Canoe dance', 'All of the above'],
    a: 3,
    e: 'All three dances — the Yoruba Bata, Igbo Atilogwu, and the Canoe dance — were performed, reflecting Nigeria\'s rich multicultural diversity at Bepo\'s send-off.',
    full: 'The farewell ceremony at Stardom Schools featured three distinct cultural dances:\n• Bata dance: a traditional Yoruba drum-based dance\n• Atilogwu dance: a high-energy Igbo acrobatic dance\n• Canoe dance: symbolising migration, survival, and Nigeria\'s historical connection to water routes\n\nThis variety deliberately showcased Nigeria\'s cultural diversity and reflected Bepo\'s philosophy of celebrating all Nigerian heritages, not just Yoruba (Stardom is in Lagos). The canoe dance proved most emotionally significant for Bepo personally.',
    h: 'How many different cultural dances were featured at Bepo\'s farewell — just one, or multiple representing Nigeria\'s diversity?',
  },
  {
    yr: 2025,
    q: 'What cultural values does the novel highlight through its depiction of dance and drama at Stardom?',
    o: [
      'The diversity and richness of Nigerian culture',
      'The unity among students',
      'The importance of art in education',
      'All of the above',
    ],
    a: 3,
    e: 'The dances and drama at Stardom showcase all three — Nigeria\'s diverse cultural richness, the unity students achieve through shared performance, and the vital role of arts in holistic education.',
    full: 'When Stardom Schools performs Bata, Atilogwu, and Canoe dances together, it achieves multiple things simultaneously. It demonstrates Nigeria\'s multicultural richness (Yoruba, Igbo, coastal traditions all represented). Students from different backgrounds perform together, building unity. And the arts are positioned not as extracurricular but as central to the school\'s educational mission — reflecting Bepo\'s belief that cultural literacy is as important as academic literacy.',
    h: 'What three values do the cultural performances at Stardom simultaneously express?',
  },
  {
    yr: 2025,
    q: 'What historical lesson did Bepo want his students to take away from Badagry?',
    o: [
      'The bravery of Nigeria\'s independence fighters',
      'The horrors of the transatlantic slave trade',
      'The importance of tourism for the economy',
      'The need to preserve Nigerian traditions',
    ],
    a: 1,
    e: 'The Badagry visit was specifically designed to confront students with the reality of the transatlantic slave trade — its routes, its scale, and its impact on Africa.',
    full: 'Badagry was one of the main embarkation points for enslaved Africans during the transatlantic slave trade. Bepo chose it deliberately to give students a physical, visceral connection to this history. Visiting the Slave Route, the Point of No Return, and the Heritage Slave Museum, students came face-to-face with the horrors of slavery. Bepo wanted this to be a lesson in humility, resilience, and the importance of never forgetting history — not a tourism exercise or a lesson about independence fighters.',
    h: 'Badagry is most historically associated with what painful chapter of African history that Bepo wanted students to understand?',
  },

  // ── Bureaucratic Challenges (Q41–45) ──────────────────────────────────────
  {
    yr: 2025,
    q: 'Why did Bepo develop a phobia for renewing his passport?',
    o: [
      'Fear of non-availability of booklets',
      'Concerns about bribery and corruption',
      'The COVID-19 pandemic',
      'All of the above',
    ],
    a: 3,
    e: 'Bepo\'s passport phobia developed from all three factors — booklet shortages, rampant bribery at immigration offices, and the disruptions caused by the COVID-19 pandemic.',
    full: 'The novel depicts Nigerian immigration offices as deeply dysfunctional. Bepo\'s reluctance to renew his passport stems from multiple compounding frustrations:\n• Passport booklets frequently ran out (non-availability)\n• Officers demanded bribes to process applications\n• COVID-19 created additional backlogs and procedural chaos\n\nThese combined experiences made passport renewal feel daunting and unpleasant, contributing to Bepo\'s delay — which in turn becomes part of why his first attempt to leave for the UK is disrupted.',
    h: 'Bepo\'s passport phobia came from multiple frustrations — was it just one problem or several?',
  },
  {
    yr: 2025,
    q: 'What did Bepo\'s wife insist he pack for his journey to the UK?',
    o: ['Egusi and iru', 'Yam and pepper', 'Rice and beans', 'Palm oil and okra'],
    a: 0,
    e: 'Bepo\'s wife insisted he pack egusi (melon seeds) and iru (fermented locust beans) — traditional Yoruba/Nigerian ingredients that would be hard to find in the UK.',
    full: 'This detail from the novel captures the cultural anxiety of migration with gentle humour and warmth. Bepo\'s wife knew that Nigerian food — especially ingredients like egusi (ground melon seeds used for egusi soup) and iru (fermented locust beans used as a flavouring agent) — would be difficult to source in the UK. Insisting he pack them was her way of keeping his cultural identity and comfort intact in a foreign land.',
    h: 'What two traditional Nigerian food ingredients did Bepo\'s wife insist he carry on his trip to the UK?',
  },
  {
    yr: 2025,
    q: 'Why did Bepo travel to Ibadan for his passport renewal instead of Lagos?',
    o: [
      'To avoid the stress in Lagos offices',
      'To visit his old university',
      'To attend a cultural festival',
      'To meet his former colleagues',
    ],
    a: 0,
    e: 'Lagos immigration offices were notoriously overcrowded and corrupt — Bepo chose Ibadan\'s office hoping for a less stressful experience.',
    full: 'The Lagos immigration office was infamous for its chaos — extremely long queues, bribery demands, and frequent booklet shortages. Bepo opted to travel to the Ibadan office, calculating that it might be less overwhelmed. This decision to bypass Lagos and seek a slightly more functional bureaucratic environment is itself a small act of navigating systemic failure — one that captures the everyday strategies Nigerians use to cope with dysfunctional public services.',
    h: 'Bepo bypassed Lagos for Ibadan — what was wrong with Lagos immigration that drove this decision?',
  },

  // ── Lessons from Leadership (Q116–120) ────────────────────────────────────
  {
    yr: 2025,
    q: 'What leadership style did Bepo employ at Stardom Schools?',
    o: [
      'Strict and authoritative',
      'Collaborative and inspiring',
      'Passive and indifferent',
      'Overbearing and micromanaging',
    ],
    a: 1,
    e: 'Bepo led collaboratively and inspirationally — working with teachers, celebrating students, and creating a shared vision rather than dictating from above.',
    full: 'The novel consistently portrays Bepo as a collaborative, servant leader. He works alongside Mrs. Gloss and other staff as colleagues, not subordinates. He invests personally in students like Jide. He builds consensus around the school\'s cultural mission. His farewell ceremony — filled with love from all quarters — is the ultimate evidence that his style was inspirational and collaborative, not authoritarian or passive.',
    h: 'Was Bepo known for his strictness, his collaboration, his passivity, or his micromanaging?',
  },
  {
    yr: 2025,
    q: 'What advice does Bepo give about cultural preservation?',
    o: [
      'It is essential for building a strong national identity',
      'It should not interfere with modernisation',
      'It should only be taught in history classes',
      'It is secondary to economic development',
    ],
    a: 0,
    e: 'Bepo views cultural preservation as foundational to national identity — not a distraction or a secondary concern, but a core educational priority.',
    full: 'Bepo\'s entire educational philosophy is built around the belief that a people who lose their culture lose themselves. His excursions, dances, Yoruba proverbs, and emphasis on historical sites are not supplementary activities — they are central to Stardom\'s identity. By preserving culture in the classroom and through field trips, Bepo argues that students build the pride, identity, and rootedness they need to contribute meaningfully to Nigeria\'s development.',
    h: 'For Bepo, was cultural preservation a core educational priority or something secondary and optional?',
  },

  // ── Bepo\'s Legacy (Q146–150) ─────────────────────────────────────────────
  {
    yr: 2025,
    q: 'What is the most enduring aspect of Bepo\'s legacy at Stardom Schools?',
    o: [
      'His cultural and historical education initiatives',
      'His personal connection with students and staff',
      'The transformation of Stardom Schools into a model institution',
      'All of the above',
    ],
    a: 3,
    e: 'All three dimensions — cultural initiatives, personal connections, and institutional transformation — together form Bepo\'s enduring legacy at Stardom Schools.',
    full: 'Bepo\'s legacy at Stardom Schools cannot be reduced to a single dimension. He leaves behind:\n• Cultural and historical education programmes (excursions, dances, debates)\n• Deep personal bonds with hundreds of students and staff members like Mrs. Gloss\n• An institution that has been transformed from a regular school into a cultural and academic beacon\n\nAll three are interconnected — the programmes built the institution, the personal bonds gave them meaning, and the transformed institution is what his students and staff will carry forward.',
    h: 'Can Bepo\'s legacy be summarised in one thing, or does it span cultural programmes, personal bonds, and institutional change?',
  },
  {
    yr: 2025,
    q: 'What message did Bepo\'s return to Stardom send to students and staff?',
    o: [
      'Commitment to one\'s mission is paramount',
      'Migration is not always the solution',
      'Leadership involves making personal sacrifices',
      'All of the above',
    ],
    a: 3,
    e: 'Bepo\'s return sent all three messages simultaneously — that mission trumps opportunity, that migration isn\'t automatically the answer, and that real leadership demands personal sacrifice.',
    full: 'Bepo\'s return was a teaching moment for the entire school community:\n1. Commitment to mission is paramount (A): he chose his vocation over a lucrative job abroad\n2. Migration is not always the solution (B): his return challenges the Japa syndrome narrative that leaving Nigeria is always better\n3. Leadership involves sacrifice (C): he gave up a settled life with his family to stay at Stardom\n\nThe fact that a single action conveyed all three messages simultaneously is part of what makes Bepo such a powerful character.',
    h: 'Bepo\'s return was rich with meaning — did it convey just one lesson or multiple lessons at once?',
  },

  // ── Final Reflections (Q186–195) ──────────────────────────────────────────
  {
    yr: 2025,
    q: 'What was the most significant lesson Bepo left with his students?',
    o: [
      'The importance of dedication and integrity',
      'The value of embracing one\'s culture',
      'The need to persevere despite challenges',
      'All of the above',
    ],
    a: 3,
    e: 'Bepo\'s lasting lesson encompassed dedication and integrity, cultural pride, and perseverance — all three were lived out through his 24 years at Stardom Schools.',
    full: 'Bepo did not deliver a single neat lesson — his life AT Stardom was the lesson. Students observed:\n• His dedication and integrity: 24 years of consistent, principled leadership\n• His cultural pride: every excursion, every proverb, every dance reinforced the value of Nigerian identity\n• His perseverance: dealing with bureaucracy, family pressure, and societal expectations without losing purpose\n\nAll three lessons were embodied, not merely preached, which is why they left such a lasting impression.',
    h: 'Was Bepo\'s final lesson to students about one virtue, or did his example embody many simultaneously?',
  },
  {
    yr: 2025,
    q: 'What is the ultimate message of the novel?',
    o: [
      'Leadership involves personal sacrifices for the greater good',
      'Cultural and historical education is vital for personal identity',
      'True fulfilment comes from serving others',
      'All of the above',
    ],
    a: 3,
    e: 'The novel\'s ultimate message is holistic — it combines the necessity of sacrifice in leadership, the centrality of cultural education, and the fulfilment found in a life of service.',
    full: 'The Lekki Headmaster is not a novel with a single, reductive message. Through Bepo\'s journey it argues:\n• That true leaders sacrifice personal comfort for their mission (A)\n• That knowing and embracing one\'s cultural history is foundational to identity (B)\n• That the deepest human fulfilment comes not from wealth or emigration but from meaningful service to others (C)\n\nThese three messages reinforce each other — together they constitute the novel\'s complete vision of what it means to live a purposeful life.',
    h: 'Is the novel\'s ultimate message about leadership, culture, or service — or all three together?',
  },
  {
    yr: 2025,
    q: 'What does Bepo\'s return to Stardom Schools at the novel\'s end symbolise?',
    o: [
      'Dedication to his mission and students',
      'A rejection of migration as an easy solution',
      'The triumph of passion over ambition',
      'All of the above',
    ],
    a: 3,
    e: 'Bepo\'s return is the novel\'s richest symbol — it simultaneously expresses his devotion to duty, rejects the easy escape of migration, and shows passion overcoming ambition.',
    full: 'The ending is the novel\'s most powerful moment precisely because Bepo\'s return carries so many meanings at once:\n• Dedication to mission: he cannot abandon his students and the school he has built (A)\n• Rejection of the easy solution: he could have left for a comfortable life in the UK but chooses not to (B)\n• Triumph of passion: his love for teaching and cultural preservation — his passion — defeats the ambition to advance his career abroad (C)\n\nAll three interpretations are valid and intended by the author.',
    h: 'Bepo\'s final return — is it best understood as dedication, rejection of migration, triumph of passion, or all three?',
  },
    
  {
    yr: 2025,
    q: 'Who is the protagonist of the novel "The Lekki Headmaster"?',
    o: ['Banky', 'Bepo', 'Mrs. Ibidun Gloss', 'Mr. Ogunwale'],
    a: 1,
    e: 'The protagonist is Bepo (Adewale Adebepo), the principal of Stardom Schools.',
    full: 'Bepo, whose full name is Adewale Adebepo, is the central character around whom the entire story revolves. He is the principal of Stardom Schools in Lekki, Lagos, and the novel follows his journey, his love for education and Nigerian culture, and his eventual decision about whether to leave Nigeria for greener pastures abroad.',
    h: 'Who is the main character of The Lekki Headmaster?',
  },
  {
    yr: 2025,
    q: 'What is the full name of the principal referred to as Bepo?',
    o: ['Bepo Adebowale', 'Adewale Adebepo', 'Adebayo Bepo', 'Adekunle Bepo'],
    a: 1,
    e: 'His full name is Adewale Adebepo — "Bepo" is the shortened, affectionate form used by students and colleagues.',
    full: 'The principal\'s full name is Adewale Adebepo. The nickname "Bepo" is derived from his surname and is used throughout the novel as a term of endearment by students, staff, and the community. He is also called "Principoo" by students as a further affectionate nickname.',
    h: 'What is Bepo\'s actual full name in the novel?',
  },
  {
    yr: 2025,
    q: 'Which teacher in "The Lekki Headmaster" was known for her witty remarks?',
    o: ['Mrs. Ibidun Gloss', 'Mrs. Apeh', 'Mr. Audu', 'Mr. Amos'],
    a: 0,
    e: 'Mrs. Ibidun Gloss is the character known for her witty remarks in the novel.',
    full: 'Mrs. Ibidun Gloss is one of the notable teachers at Stardom Schools. She is characterised by her quick wit and sharp remarks, which made her memorable to both students and colleagues. She also deeply respected Bepo\'s contributions to the school and delivered a heartfelt speech at his farewell ceremony.',
    h: 'Which teacher at Stardom Schools was famous for being witty?',
  },
  {
    yr: 2025,
    q: 'Who were the two students involved in a rivalry dating back to JSS 3?',
    o: ['Banky and Toss', 'Jide and Kemi', 'Seri and Tai', 'Ogba and Tosh'],
    a: 0,
    e: 'Banky and Toss had a rivalry that began as far back as JSS 3.',
    full: 'Banky and Toss (sometimes written as Tosh) had an ongoing rivalry rooted in family politics and personal conflict that began in JSS 3. Their rivalry escalates to a flashpoint during the prefect election speech, when Banky insults Toss\'s father, triggering a significant conflict in the school. Their rivalry reflects the novel\'s theme of family and politics.',
    h: 'Which two students had a JSS 3 rivalry in The Lekki Headmaster?',
  },
  {
    yr: 2025,
    q: 'Which character in "The Lekki Headmaster" is deeply committed to African history and culture?',
    o: ['Mr. Ogunwale', 'Bepo', 'Jide', 'Mrs. Gloss'],
    a: 1,
    e: 'Bepo is the character most deeply committed to African history and culture throughout the novel.',
    full: 'Bepo\'s passion for African history and culture is one of his defining traits. He organises excursions to historical sites like the Badagry Slave Museum and Ikogosi Warm Springs to connect students with their heritage. He also coaches his landlord\'s grandson Jide in elocution and African history, showing that his commitment to culture extends beyond the school walls.',
    h: 'Who is the most passionate about African culture in The Lekki Headmaster?',
  },
  {
    yr: 2025,
    q: 'What theme is central to the rivalry between Banky and Toss?',
    o: ['Democracy', 'Social justice', 'Family and politics', 'Cultural diversity'],
    a: 2,
    e: 'The rivalry between Banky and Toss is rooted in and driven by family and political tensions.',
    full: 'The rivalry between Banky and Toss is not merely personal — it is deeply entangled with their family backgrounds and political allegiances. The conflict comes to a head during the prefect election speech when Banky insults Toss\'s father, revealing the political and familial dimensions of their antagonism. This makes "family and politics" the central theme of their rivalry.',
    h: 'What underlying theme fuels the Banky-Toss rivalry?',
  },
  {
    yr: 2025,
    q: 'The recurring phrase "If you say education is expensive, try ignorance" in "The Lekki Headmaster" reflects which theme?',
    o: ['Importance of hard work', 'Value of education', 'Leadership struggles', 'Sacrifice and dedication'],
    a: 1,
    e: 'This phrase directly reflects the theme of the value of education — highlighting that the cost of ignorance far outweighs the cost of education.',
    full: 'The phrase "If you say education is expensive, try ignorance" is one of the key quotes in The Lekki Headmaster. It encapsulates Bepo\'s core philosophy and the novel\'s central message: education, no matter how costly or difficult, is worth it. Ignorance carries a far greater price — social, economic, and cultural. The phrase serves as a rallying cry for Bepo\'s commitment to quality education at Stardom Schools.',
    h: 'What theme does "If you say education is expensive, try ignorance" represent?',
  },
  {
    yr: 2025,
    q: 'The novel "The Lekki Headmaster" explores the effects of migration under which term?',
    o: ['Brain Drain', 'Japa Syndrome', 'Wanderlust', 'Exodus'],
    a: 1,
    e: 'The novel specifically uses the term "Japa Syndrome" to describe the phenomenon of Nigerians leaving the country for better opportunities abroad.',
    full: '"Japa" is a Yoruba slang meaning to run or escape quickly. In contemporary Nigerian usage, it refers to emigrating from Nigeria in search of better opportunities abroad. The novel uses "Japa Syndrome" to describe the wave of Nigerians — especially talented professionals like Bepo — who are tempted to leave. The novel critiques this phenomenon by showing the emotional cost, the brain drain it causes, and ultimately, through Bepo\'s return, questions whether leaving is always the right answer.',
    h: 'What Nigerian slang term does the novel use to describe mass emigration abroad?',
  },
  {
    yr: 2025,
    q: 'What theme is highlighted through the depiction of the Badagry slave museum in "The Lekki Headmaster"?',
    o: ['Liberation', 'Historical memory', 'African resilience', 'Colonization'],
    a: 1,
    e: 'The Badagry slave museum is used in the novel to emphasise the theme of historical memory — the importance of remembering and not forgetting the past.',
    full: 'The Badagry slave museum, including the Point of No Return, serves as a powerful symbol of historical memory in the novel. When Bepo takes his students there, the visit is designed to connect them with a painful but important chapter of African history — the transatlantic slave trade. The experience is also personally significant for Bepo, as the imagery of the slave trade evokes emotions about his own potential "departure" from Nigeria.',
    h: 'What theme does the Badagry slave museum visit represent in the novel?',
  },
  {
    yr: 2025,
    q: 'The sacrifices made by Bepo in "The Lekki Headmaster" reflect which central theme?',
    o: ['Family loyalty', 'Dedication to duty', 'Political ambition', 'Cultural preservation'],
    a: 1,
    e: 'Bepo\'s many personal sacrifices throughout the novel reflect the central theme of dedication to duty — putting his mission above personal comfort.',
    full: 'Throughout the novel, Bepo makes numerous sacrifices for Stardom Schools and his students. He endures bureaucratic frustrations (passport renewal), resists the lure of migration, and ultimately chooses to return to the school even after planning to leave. All of these actions reflect an unwavering dedication to duty — his belief that his purpose lies in serving his students and preserving Nigerian culture through education.',
    h: 'What central theme do Bepo\'s many personal sacrifices reflect?',
  },
  {
    yr: 2025,
    q: 'Why was Bepo reluctant to renew his passport?',
    o: [
      'He feared the stress at the immigration office',
      'He had no plans to travel abroad',
      'He lacked the funds for renewal',
      'He was unaware it had expired',
    ],
    a: 0,
    e: 'Bepo was reluctant to renew his passport because he feared the stress and difficulty of dealing with the immigration office.',
    full: 'Bepo developed a strong reluctance — almost a phobia — around renewing his passport due to the notorious difficulties at Nigerian immigration offices: long queues, corrupt officials, scarcity of booklets, and the general inefficiency of the system. This experience is used in the novel to critique corruption and bureaucratic decay in Nigeria. He eventually travels to Ibadan to renew it, hoping to avoid the Lagos office chaos.',
    h: 'What made Bepo dread the passport renewal process?',
  },
  {
    yr: 2025,
    q: 'What led to the conflict during the prefect election speech in "The Lekki Headmaster"?',
    o: [
      'Banky insulted Tosh\'s father',
      'A bribe scandal emerged',
      'Bepo intervened in the voting process',
      'Tosh accused the school of favouritism',
    ],
    a: 0,
    e: 'The conflict during the prefect election speech was triggered when Banky insulted Tosh\'s father.',
    full: 'During the prefect election speech, the long-running rivalry between Banky and Toss (Tosh) exploded into open conflict when Banky made a remark insulting Toss\'s father. This broke the decorum of the event and escalated the rivalry to its most visible point in the novel. The incident illustrates how family and political loyalties can intrude even into school activities.',
    h: 'What specific action by Banky caused the conflict at the prefect election?',
  },
  {
    yr: 2025,
    q: 'What project was the Invention Club at Stardom Schools working on?',
    o: ['A recycling initiative', 'A phone-making project', 'A solar-powered device', 'A wind turbine'],
    a: 1,
    e: 'The Invention Club at Stardom Schools was working on a phone-making project.',
    full: 'The Invention Club at Stardom Schools represents Bepo\'s commitment to practical, innovative education. The students were working on a phone-making project — an ambitious initiative that reflects the school\'s emphasis on STEM, creativity, and hands-on learning. This project is part of the broader "Breath Project" (recycling initiative) theme in the novel that showcases the school\'s forward-thinking educational approach.',
    h: 'What was the Invention Club at Stardom Schools building?',
  },
  {
    yr: 2025,
    q: 'What delayed Bepo\'s first trip to the UK?',
    o: [
      'He misread the flight time',
      'The airport was overcrowded',
      'His passport was invalid',
      'He had an emergency meeting',
    ],
    a: 0,
    e: 'Bepo misread the flight time, which caused him to miss or be late for his first scheduled trip to the UK.',
    full: 'In a moment that blends humour with pathos, Bepo misreads the time of his flight to the UK, causing a significant delay to his first trip abroad. This incident highlights Bepo\'s unfamiliarity with international travel logistics and adds to the novel\'s characterisation of him as someone more at home in the Nigerian educational environment than in the world of international mobility.',
    h: 'What simple mistake delayed Bepo\'s first UK trip?',
  },
  {
    yr: 2025,
    q: 'How did Bepo\'s colleagues describe his impact on Stardom Schools?',
    o: ['Inspirational and transformative', 'Strict but fair', 'Visionary and diplomatic', 'Reserved but effective'],
    a: 0,
    e: 'Bepo\'s colleagues described his impact as inspirational and transformative — he changed the school fundamentally for the better.',
    full: 'Bepo\'s 24 years at Stardom Schools left a deep and lasting impact. His colleagues — including Mrs. Ibidun Gloss and the MD — consistently described him as inspirational and transformative. Under his leadership, the school became a cultural and educational beacon that integrated Nigerian history and cultural education with strong academics. His farewell ceremony was a testament to just how deeply his influence was felt.',
    h: 'How did staff describe the effect Bepo had on Stardom Schools?',
  },
  {
    yr: 2025,
    q: 'Where is Stardom Schools located?',
    o: ['Lekki', 'Badagry', 'Ikoyi', 'Ibadan'],
    a: 0,
    e: 'Stardom Schools is located in Lekki, Lagos — which is the basis for the novel\'s title "The Lekki Headmaster."',
    full: 'Stardom Schools is set in the Lekki area of Lagos, Nigeria. The school\'s location in one of Lagos\'s affluent and rapidly developing neighbourhoods adds context to the story\'s themes about modern Nigerian society, education, and the Japa syndrome. The title "The Lekki Headmaster" directly references this setting and Bepo\'s role there.',
    h: 'In which Lagos neighbourhood is Stardom Schools located?',
  },
  {
    yr: 2025,
    q: 'What significant historical location(s) did the students visit in Badagry?',
    o: ['First Storey Building', 'Slave Market', 'Point of No Return', 'All of the above'],
    a: 3,
    e: 'The students visited multiple historical sites in Badagry: the First Storey Building, the Slave Route/Market, and the Point of No Return.',
    full: 'Bepo\'s excursion to Badagry was comprehensive. The students visited the First Storey Building (the first Western-style building in Nigeria, built by missionaries), the slave market/museum and the slave route, and the famous Point of No Return — the spot from which enslaved Africans were loaded onto ships, never to return. All of these sites are real historical landmarks in Badagry, and the novel uses them to teach students about Nigeria\'s painful history.',
    h: 'Which historical sites in Badagry did Stardom students visit?',
  },
  {
    yr: 2025,
    q: 'What tourist attraction in Ekiti did the students of Stardom Schools explore?',
    o: ['Ikogosi Warm Springs', 'Erin Ijesha Waterfalls', 'Arinta Waterfalls', 'Yankari Games Reserve'],
    a: 0,
    e: 'The students visited Ikogosi Warm Springs in Ekiti State.',
    full: 'Ikogosi Warm Springs is a unique natural attraction in Ekiti State where warm and cold springs meet side by side without mixing. Bepo organised a visit there as part of his commitment to exposing students to Nigeria\'s natural wonders and tourism potential. The visit is part of his broader educational philosophy that learning should extend beyond the classroom.',
    h: 'Which natural Ekiti attraction did Stardom students visit?',
  },
  {
    yr: 2025,
    q: 'Which Lagos market is known in "The Lekki Headmaster" for its bustling trade and Yoruba proverbs?',
    o: ['Balogun Market', 'Oyingbo Market', 'Idumota Market', 'Tejuosho Market'],
    a: 1,
    e: 'Oyingbo Market is the Lagos market referenced in the novel for its bustling trade and association with Yoruba proverbs.',
    full: 'Oyingbo Market in Lagos is referenced in the novel as a vibrant, culturally rich marketplace. The Yoruba proverb "Oja Oyingbo ko mo eni kan o wa" (Oyingbo Market does not care who is absent) is quoted, illustrating how life goes on regardless of individual departures — a theme relevant to Bepo\'s potential exit from Stardom Schools.',
    h: 'Which market is referenced alongside a Yoruba proverb in The Lekki Headmaster?',
  },
  {
    yr: 2025,
    q: 'What location is associated with the phrase "Point of No Return" in "The Lekki Headmaster"?',
    o: ['Badagry Slave Museum', 'First Storey Building', 'Arinta Waterfalls', 'Heritage Slave Museum'],
    a: 0,
    e: 'The "Point of No Return" is associated with the Badagry Slave Museum and the slave route in Badagry.',
    full: 'The Point of No Return is the historical site in Badagry where enslaved Africans were marched to the shore to be loaded onto slave ships during the transatlantic slave trade. It is called the "Point of No Return" because once enslaved people crossed that point, they would never return to Africa. In the novel, this site serves as a powerful symbol of loss, historical trauma, and the emotional weight of departure — mirroring Bepo\'s own impending departure from Nigeria.',
    h: 'Which site in Badagry is called the "Point of No Return"?',
  },
  {
    yr: 2025,
    q: 'What does the Point of No Return symbolise in "The Lekki Headmaster"?',
    o: ['A new beginning', 'Historical slavery', 'Freedom and independence', 'Migration'],
    a: 1,
    e: 'In the novel, the Point of No Return primarily symbolises historical slavery — the departure point of enslaved Africans who never returned.',
    full: 'The Point of No Return is deeply symbolic in the novel on multiple levels. Most directly, it represents the horrors of historical slavery — the point from which enslaved Africans departed the continent forever. Secondarily, it serves as a metaphor for Bepo\'s own situation as he contemplates leaving Nigeria, drawing a parallel between voluntary modern migration and the forced migration of slavery. The symbol makes Bepo question his own "point of no return."',
    h: 'What does the Point of No Return primarily symbolise in the novel?',
  },
  {
    yr: 2025,
    q: 'The canoe dance performed at Stardom Schools symbolises what in "The Lekki Headmaster"?',
    o: ['Migration and survival', 'Unity and diversity', 'Hope and resilience', 'Loss and restoration'],
    a: 0,
    e: 'The canoe dance symbolises migration and survival — representing the journey across waters and the resilience of those who endure it.',
    full: 'The canoe dance is one of the most emotionally significant moments in the novel. It is performed during Bepo\'s farewell ceremony and its imagery evokes the journey of enslaved Africans across the Atlantic — people forced into canoes, crossing vast waters, never to return. For Bepo, watching the dance triggers deep emotion, as he sees in it a reflection of his own impending journey away from Nigeria and the cultural roots he loves.',
    h: 'What does the canoe dance performed at Stardom represent symbolically?',
  },
  {
    yr: 2025,
    q: 'What does Bepo\'s dream of the slave museum represent in "The Lekki Headmaster"?',
    o: ['Nostalgia for Nigeria', 'The horrors of slavery', 'His emotional struggle with leaving home', 'A call for justice'],
    a: 2,
    e: 'Bepo\'s dream of the slave museum represents his emotional struggle with leaving home — his subconscious processing the weight of departure.',
    full: 'At the airport, before his departure, Bepo has a vivid dream involving the slave museum at Badagry. The dream is not simply about slavery — it is a manifestation of his inner conflict about leaving Nigeria. The museum, with its imagery of people forced to leave and never return, becomes a metaphor for his own voluntary departure. The dream shows that deep down, Bepo\'s heart is not ready to leave — setting up his eventual decision to return to Stardom.',
    h: 'What does Bepo\'s airport dream about the slave museum reveal about his inner state?',
  },
  {
    yr: 2025,
    q: 'What does the banner at Bepo\'s farewell in "The Lekki Headmaster" signify?',
    o: ['Recognition of his efforts', 'Celebration of his departure', 'Hope for a new principal', 'Continuity in leadership'],
    a: 0,
    e: 'The farewell banner signifies recognition of Bepo\'s efforts and contributions to Stardom Schools.',
    full: 'The farewell banner prepared for Bepo is a visual representation of the school community\'s gratitude and recognition of his 24 years of service. It is a tribute to his transformative impact on Stardom Schools — his cultural education programmes, his personal mentorship, and his dedication to students. The banner, along with the cultural performances and speeches, forms a comprehensive celebration of his legacy.',
    h: 'What does the farewell banner at Bepo\'s send-off represent?',
  },
  {
    yr: 2025,
    q: 'The phrase "Japa syndrome" in "The Lekki Headmaster" is symbolic of what?',
    o: [
      'The loss of talent to foreign lands',
      'A desire for better opportunities',
      'Escapism',
      'All of the above',
    ],
    a: 3,
    e: '"Japa syndrome" symbolises all three: the brain drain (loss of talent), the desire for better opportunities, and a form of escapism from Nigeria\'s challenges.',
    full: '"Japa syndrome" is a multi-layered symbol in the novel. It represents the brain drain — the exodus of Nigeria\'s best and brightest to foreign countries. It reflects a legitimate desire for better opportunities, quality of life, and professional growth. But the novel also critiques it as a form of escapism — running away from problems rather than staying to solve them. Bepo\'s journey explores all these dimensions, and his ultimate return questions whether Japa is always the answer.',
    h: 'What are all the things "Japa syndrome" symbolises in The Lekki Headmaster?',
  },
  {
    yr: 2025,
    q: 'What was the "Breath Project" about in "The Lekki Headmaster"?',
    o: [
      'Using recycled materials to make inventions',
      'Promoting clean energy',
      'Introducing environmental education',
      'Teaching life-saving techniques',
    ],
    a: 0,
    e: 'The Breath Project was about using recycled materials to create inventions — an environmental and creative initiative at Stardom Schools.',
    full: 'The Breath Project is an innovative initiative at Stardom Schools where students use recycled and waste materials to create useful inventions. It reflects Bepo\'s philosophy of practical, creative, and environmentally conscious education. The project teaches students to look at discarded materials as resources and to solve problems creatively — values that align with Bepo\'s broader mission of developing well-rounded, culturally and practically equipped students.',
    h: 'What was the purpose of the Breath Project at Stardom Schools?',
  },
  {
    yr: 2025,
    q: 'Who said "If you want a debtor to lead, ask a tenant to lead the landlord" in "The Lekki Headmaster"?',
    o: ['Bepo', 'Mrs. Gloss', 'Mr. Amos', 'Banky'],
    a: 1,
    e: 'Mrs. Ibidun Gloss said this witty remark.',
    full: 'This sharp, witty remark is attributed to Mrs. Ibidun Gloss, who was known throughout the novel for her clever and incisive observations. The statement is a proverbial warning about placing unqualified or compromised people in positions of authority — a commentary that could apply to various situations in the school or Nigerian society more broadly.',
    h: 'Which character made the witty remark about a tenant leading a landlord?',
  },
  {
    yr: 2025,
    q: 'What was the final cultural performance at Bepo\'s send-off in "The Lekki Headmaster"?',
    o: ['Igbo Atilogwu Dance', 'Yoruba Bata Dance', 'Hausa Koroso Dance', 'Canoe Dance'],
    a: 3,
    e: 'The Canoe Dance was the final and most emotionally significant cultural performance at Bepo\'s send-off.',
    full: 'Although the farewell ceremony featured multiple cultural performances including the Atilogwu dance and the Bata dance, the Canoe Dance was the climactic final performance. It was the one that moved Bepo most deeply, causing him to shout "Nooo!" in anguish — a reaction that reveals his deep emotional connection to Nigerian culture and his inner conflict about leaving. The canoe dance\'s symbolism of people crossing waters away from home made it personally devastating for Bepo.',
    h: 'Which dance was performed last and affected Bepo most emotionally at his farewell?',
  },
  {
    yr: 2025,
    q: 'How did the school honour Bepo\'s contributions at his farewell?',
    o: ['By presenting him with a $10,000 check', 'By naming a hall after him', 'By hosting an international cultural show', 'By organising a national award ceremony'],
    a: 0,
    e: 'The school presented Bepo with a $10,000 check as a farewell gift in recognition of his 24 years of service.',
    full: 'At Bepo\'s farewell ceremony, Stardom Schools presented him with a financial gift of $10,000 as a tangible token of appreciation for his 24 years of dedicated service. This was accompanied by cultural performances, speeches from Mrs. Gloss and the MD, and a farewell banner. The $10,000 gift symbolised the community\'s deep gratitude and recognition of his transformative impact on the school.',
    h: 'What financial gift did Stardom Schools give Bepo at his farewell?',
  },
  {
    yr: 2025,
    q: 'Why did Bepo ultimately choose to stay back at Stardom Schools?',
    o: [
      'He missed his flight',
      'His heart and mission were with the school',
      'His family insisted he stay',
      'He feared life abroad',
    ],
    a: 1,
    e: 'Bepo chose to return because his heart and mission were with Stardom Schools — he realised he could not abandon what he had spent 24 years building.',
    full: 'After going through the entire farewell process and reaching the airport, Bepo experiences a powerful emotional reckoning. His dream at the airport, the memory of the canoe dance, and his deep connection to his students and mission compel him to turn back. He returns to Stardom Schools on the Monday after his supposed departure, demonstrating that true purpose and passion outweigh the allure of migration. His return is the emotional and thematic climax of the novel.',
    h: 'What ultimately made Bepo turn back from leaving Nigeria?',
  },
  {
    yr: 2025,
    q: 'What was the main purpose of the excursions organised by Stardom Schools?',
    o: [
      'To entertain the students',
      'To expose students to Nigerian history and culture',
      'To encourage students to travel abroad',
      'To give teachers a break',
    ],
    a: 1,
    e: 'The excursions were primarily organised to expose students to Nigerian history and culture — a core part of Bepo\'s educational philosophy.',
    full: 'Bepo believed strongly that education could not be confined to classrooms. The excursions to Badagry (slave history), Ikogosi Warm Springs (natural wonders), and other sites were specifically designed to give students firsthand encounters with Nigerian heritage. Bepo wanted his students to know where they came from, to feel connected to their culture, and to be proud Nigerians — not just recipients of a Westernised curriculum.',
    h: 'What educational purpose did Bepo\'s excursions serve?',
  },
  {
    yr: 2025,
    q: 'What was the outcome of the debate held in Bepo\'s honour?',
    o: ['The science team won', 'The arts team won', 'The teachers were the judges', 'It was inconclusive'],
    a: 0,
    e: 'The science team won the debate held in Bepo\'s honour.',
    full: 'A debate was organised as part of the events honouring Bepo during his farewell period. The science team emerged victorious over the arts team. A commenter on the lasu-info.com source confirmed this correction (the original answer listed B before being corrected to A). The debate, like the other farewell events, was a celebration of the intellectual culture Bepo had nurtured at Stardom Schools.',
    h: 'Which team won the debate organised in Bepo\'s honour?',
  },
  {
    yr: 2025,
    q: 'Why did Bepo emphasise excursions to historical sites?',
    o: [
      'To encourage students to pursue tourism careers',
      'To deepen their connection with Nigerian heritage',
      'To prepare them for international travel',
      'To create publicity for Stardom Schools',
    ],
    a: 1,
    e: 'Bepo emphasised historical site excursions specifically to deepen students\' connection with Nigerian heritage and cultural identity.',
    full: 'For Bepo, excursions to historical sites were not recreational — they were pedagogical. He wanted his students to feel the weight of history, to understand their roots, and to develop a deep emotional and intellectual connection with Nigerian heritage. Visiting places like the Badagry slave museum and the Point of No Return was his way of making history tangible and personal, ensuring it was not just a subject in a textbook but a lived experience.',
    h: 'What was Bepo\'s primary reason for taking students to historical sites?',
  },
  {
    yr: 2025,
    q: 'What key value did Bepo try to instil in the students of Stardom Schools?',
    o: ['Resilience', 'Creativity', 'Leadership', 'Patriotism'],
    a: 3,
    e: 'Patriotism — love for Nigeria and pride in its culture and history — was the key value Bepo most consistently tried to instil.',
    full: 'Above all, Bepo wanted his students to be patriots — to love Nigeria, to understand its history, to be proud of its culture, and to want to contribute to its development. His cultural education programmes, historical excursions, and emphasis on African heritage were all in service of this goal. His own decision to return to Stardom rather than migrate abroad is the ultimate expression of patriotism the novel promotes.',
    h: 'What was the most important value Bepo worked to instil in his students?',
  },
  {
    yr: 2025,
    q: 'How were prefects elected at Stardom Schools?',
    o: [
      'Appointed by the management',
      'Elected through a democratic process',
      'Chosen by a panel of alumni',
      'Randomly selected',
    ],
    a: 1,
    e: 'Prefects at Stardom Schools were elected through a democratic process involving speeches and voting.',
    full: 'The democratic election of prefects at Stardom Schools is significant in the novel because it is the context for the Banky-Toss conflict. Students participated in a speech-making process before voting, giving all candidates the opportunity to make their case. This democratic approach reflects Bepo\'s values of fairness, student empowerment, and civic education. However, the process also exposes how personal rivalries and family politics can corrupt even well-intentioned democratic processes.',
    h: 'How did students become prefects at Stardom Schools?',
  },
  {
    yr: 2025,
    q: 'What significant event does the Point of No Return highlight in "The Lekki Headmaster"?',
    o: ['Nigeria\'s independence', 'The transatlantic slave trade', 'African migration to Europe', 'The end of colonisation'],
    a: 1,
    e: 'The Point of No Return highlights the transatlantic slave trade — the departure point of millions of enslaved Africans.',
    full: 'The Point of No Return in Badagry is directly associated with the transatlantic slave trade. It is the coastal point from which enslaved Africans were forced onto ships to cross the Atlantic Ocean to the Americas. Millions never returned. In the novel, this site serves as both a history lesson for Bepo\'s students and a personal metaphor for Bepo\'s own contemplated departure from Nigeria — creating a powerful parallel between historical forced migration and modern voluntary migration.',
    h: 'What historical event does the Point of No Return commemorate?',
  },
  {
    yr: 2025,
    q: 'Why did Bepo feel emotional during the canoe dance performance?',
    o: [
      'It reminded him of slavery\'s horrors',
      'It symbolised his love for Nigeria',
      'It was his favourite dance',
      'It marked his departure from Stardom',
    ],
    a: 0,
    e: 'The canoe dance\'s imagery of people being rowed across water reminded Bepo of the horrors of the slave trade, triggering deep emotion.',
    full: 'The canoe dance evoked the imagery of enslaved Africans being transported across the ocean in canoes and ships. Having recently visited the Badagry slave museum with his students, Bepo was already emotionally primed to feel the weight of that history. When the dance was performed at his farewell, the connection between the slaves\' forced departure and his own planned voluntary departure overwhelmed him — causing him to shout "Nooo!" in a moment of raw emotional revelation.',
    h: 'What imagery in the canoe dance triggered Bepo\'s strong emotional reaction?',
  },
  {
    yr: 2025,
    q: 'What historical figure translated the Yoruba Bible according to "The Lekki Headmaster"?',
    o: ['Rev. Samuel Ajayi Crowther', 'Chief Didi Ogba', 'J.P. Clark', 'Rev. McGee'],
    a: 0,
    e: 'Rev. Samuel Ajayi Crowther translated the Yoruba Bible. He was the first African Anglican bishop and a pioneering figure in Nigerian history.',
    full: 'Rev. Samuel Ajayi Crowther (c. 1809–1891) was a remarkable historical figure — a Yoruba man who was captured as a slave, later freed, educated by missionaries, and went on to become the first African Anglican bishop. Among his many achievements was the translation of the Bible into the Yoruba language, making scripture accessible to Yoruba-speaking people. His story and the First Storey Building in Badagry (associated with missionary work) are referenced in the novel as part of the students\' historical education.',
    h: 'Who translated the Bible into Yoruba, as referenced in The Lekki Headmaster?',
  },
  {
    yr: 2025,
    q: 'Why did the students visit Badagry\'s Heritage Slave Museum?',
    o: [
      'To learn about the transatlantic slave trade',
      'To participate in a cultural dance',
      'To conduct historical research',
      'To perform at a national festival',
    ],
    a: 0,
    e: 'The students visited the Heritage Slave Museum to learn firsthand about the transatlantic slave trade and its impact.',
    full: 'The visit to Badagry\'s Heritage Slave Museum was a deliberate educational choice by Bepo. He wanted his students to encounter the history of the slave trade not as an abstract textbook concept but as a tangible, emotional experience. The museum\'s artefacts, the slave route, and the Point of No Return combined to give students a visceral understanding of one of history\'s greatest atrocities — and of their own ancestral heritage.',
    h: 'What educational objective did Bepo have in taking students to the Badagry Slave Museum?',
  },
  {
    yr: 2025,
    q: 'Why did Bepo develop a phobia for renewing his passport?',
    o: [
      'Fear of non-availability of booklets',
      'Concerns about bribery and corruption',
      'The COVID-19 pandemic',
      'All of the above',
    ],
    a: 3,
    e: 'All three factors contributed: fear of booklet unavailability, bribery and corruption at immigration offices, and the disruption caused by the COVID-19 pandemic.',
    full: 'Bepo\'s passport renewal phobia is built on multiple layers of bad experience and justified fear. Nigerian immigration offices have historically been plagued by booklet shortages (physical passport books running out), demands for bribes to process applications, and extreme inefficiency. The COVID-19 pandemic added another layer — offices were closed or at reduced capacity, making the already difficult process even more uncertain. All of these combined to make Bepo deeply averse to the renewal process.',
    h: 'What combination of factors made Bepo dread passport renewal?',
  },
  {
    yr: 2025,
    q: 'What did Bepo\'s wife insist he pack for his journey abroad?',
    o: ['Egusi and iru', 'Yam and pepper', 'Rice and beans', 'Palm oil and okra'],
    a: 0,
    e: 'Bepo\'s wife insisted he pack egusi (melon seeds) and iru (locust beans) for his trip — staple Nigerian ingredients for cooking abroad.',
    full: 'In a detail that is both humorous and culturally resonant, Bepo\'s wife insists he pack egusi (ground melon seeds used in Nigerian soups) and iru (fermented locust beans used as a flavouring) for his journey to the UK. This is a common practice among Nigerians travelling abroad — ensuring they can still cook their favourite dishes. The detail grounds the novel in authentic Nigerian domestic life and adds a touch of warmth and familiarity to the preparations for departure.',
    h: 'What Nigerian food items did Bepo\'s wife pack for his journey abroad?',
  },
  {
    yr: 2025,
    q: 'Why did Bepo travel to Ibadan for his passport renewal?',
    o: [
      'To avoid the stress in Lagos offices',
      'To visit his old university',
      'To attend a cultural festival',
      'To meet his former colleagues',
    ],
    a: 0,
    e: 'Bepo travelled to Ibadan specifically to avoid the notorious stress and chaos of Lagos immigration offices.',
    full: 'Rather than face the Lagos immigration offices — known for their corruption, crowds, and inefficiency — Bepo decided to travel to Ibadan to renew his passport there. He believed the Ibadan office would be calmer and less corrupt. The decision highlights his practical problem-solving approach but also serves as a commentary on how Nigerians are forced to navigate around systemic dysfunction rather than confronting it directly.',
    h: 'Why did Bepo go to Ibadan rather than Lagos to renew his passport?',
  },
  {
    yr: 2025,
    q: 'What phrase describes Bepo\'s perception of the Lagos-Ibadan Expressway?',
    o: ['A symbol of progress', 'The most important road in Nigeria', 'A highway to heaven', 'A waste of resources'],
    a: 1,
    e: 'Bepo perceives the Lagos-Ibadan Expressway as the most important road in Nigeria.',
    full: 'The Lagos-Ibadan Expressway is one of Nigeria\'s most critical arterial roads, connecting the commercial capital Lagos to Ibadan, the largest city in West Africa by land area. Bepo\'s characterisation of it as "the most important road in Nigeria" reflects its economic and social significance. However, the expressway is also notorious for its poor state of repair, traffic congestion, and frequent accidents — making the characterisation bitterly ironic, as the novel also uses it to critique Nigeria\'s infrastructural decay.',
    h: 'How does Bepo describe the Lagos-Ibadan Expressway?',
  },
  {
    yr: 2025,
    q: 'What major challenge did Bepo face during his NIN validation?',
    o: ['Poor network', 'Corruption among officials', 'Long queues', 'None of the above'],
    a: 0,
    e: 'Bepo faced poor network connectivity as the major challenge during his NIN (National Identification Number) validation.',
    full: 'The NIN (National Identification Number) is a biometric identity number that Nigerians are required to link to their SIM cards, passport applications, and other official processes. When Bepo attempts to complete his NIN validation as part of his passport renewal process, he encounters the chronic problem of poor network connectivity — a familiar frustration for millions of Nigerians trying to access digital government services. This detail is part of the novel\'s broader critique of Nigeria\'s infrastructure.',
    h: 'What technological problem frustrated Bepo during his NIN validation?',
  },
  {
    yr: 2025,
    q: 'How did the students and staff honour Bepo at his send-off?',
    o: [
      'A farewell banner',
      'A debate and cultural performances',
      'A financial gift',
      'All of the above',
    ],
    a: 3,
    e: 'All of the above: the students and staff honoured Bepo with a farewell banner, a debate, cultural performances, and a $10,000 financial gift.',
    full: 'Bepo\'s farewell was a comprehensive celebration of his 24-year legacy. It included: a farewell banner recognising his contributions; a debate competition that showcased the intellectual culture he had built; cultural performances including the Atilogwu dance, Bata dance, Koroso dance, and the climactic Canoe Dance; heartfelt speeches from Mrs. Gloss and the MD; and a $10,000 cash gift. The totality of these gestures demonstrated how deeply Bepo was loved and respected.',
    h: 'What combination of gestures was used to honour Bepo at his farewell?',
  },
  {
    yr: 2025,
    q: 'What performance caused Bepo to become deeply emotional at his send-off?',
    o: ['The Bata dance', 'The Atilogwu dance', 'The Canoe dance', 'The Koroso dance'],
    a: 2,
    e: 'The Canoe dance was the performance that moved Bepo most deeply, causing him to shout "Nooo!" in anguish.',
    full: 'Of all the cultural performances at his farewell, the Canoe dance struck Bepo most profoundly. Its imagery of people being rowed across water in canoes connected directly in his mind to the slave trade he had witnessed at Badagry — people leaving Africa forever. The parallel to his own impending departure from Nigeria overwhelmed him emotionally, and he cried out "Nooo!" — a visceral expression of his deep reluctance to leave. This moment is the emotional turning point of the novel.',
    h: 'Which farewell performance caused Bepo to cry out "Nooo!" in anguish?',
  },
  {
    yr: 2025,
    q: 'How much was Bepo given as a farewell gift?',
    o: ['$5,000', '$10,000', '$15,000', '$20,000'],
    a: 1,
    e: 'Bepo was given $10,000 as his farewell gift from Stardom Schools.',
    full: 'Stardom Schools presented Bepo with a $10,000 cash gift at his farewell ceremony. This significant sum reflects the school\'s appreciation for his 24 years of transformative service. The gift is symbolic as well as practical — it represents the community\'s recognition that Bepo\'s contributions cannot be adequately quantified but that they feel compelled to honour them in a meaningful and generous way.',
    h: 'What was the monetary value of Bepo\'s farewell gift?',
  },
  {
    yr: 2025,
    q: 'What Yoruba proverb did Bepo\'s farewell speech reference?',
    o: [
      '"Oja Oyingbo ko mo eni kan o wa."',
      '"Iku ya ju esin lo."',
      '"B\'Onirise ofungba mo, eyi to ti f\'in sile ko le p\'arun."',
      '"Ebi kii tan ni ile, ko se ni ajeji."',
    ],
    a: 2,
    e: 'The proverb "B\'Onirise ofungba mo, eyi to ti f\'in sile ko le p\'arun" was referenced in Bepo\'s farewell speech.',
    full: 'The Yoruba proverb referenced in Bepo\'s farewell speech is "B\'Onirise ofungba mo, eyi to ti f\'in sile ko le p\'arun" — roughly meaning "If the deity of fate has bound one, that which one has left behind cannot cure the ailment." It is a profound saying about destiny, the past, and the inescapable nature of one\'s roots. In context, it speaks to Bepo\'s spiritual and emotional connection to Nigeria and Stardom Schools — the suggestion that what he has left behind (his mission, his students) will continue to call him back.',
    h: 'Which Yoruba proverb was central to Bepo\'s farewell speech?',
  },
  {
    yr: 2025,
    q: 'What was Bepo\'s reaction during the canoe dance at his farewell?',
    o: [
      'He applauded enthusiastically',
      'He became emotional and shouted "Nooo!"',
      'He left the hall abruptly',
      'He joined the performance',
    ],
    a: 1,
    e: 'Bepo became overwhelmed with emotion during the canoe dance and shouted "Nooo!" — a spontaneous cry of anguish.',
    full: 'When the canoe dance was performed at his farewell ceremony, Bepo was so deeply moved that he cried out "Nooo!" — an involuntary, raw expression of emotional pain. The dance\'s imagery (canoes, crossing water, departure) connected with his recent experience at the Badagry slave museum and with his own impending departure. This moment of emotional breakdown is one of the most powerful scenes in the novel and is what ultimately catalyses his decision to return to Stardom rather than leave Nigeria.',
    h: 'What was Bepo\'s famous involuntary reaction to the canoe dance?',
  },
  {
    yr: 2025,
    q: 'What happened on the Monday after Bepo\'s departure in "The Lekki Headmaster"?',
    o: [
      'Students refused to enter the school',
      'Students mourned his absence',
      'Mrs. Gloss announced a new principal',
      'Bepo returned unexpectedly',
    ],
    a: 3,
    e: 'Bepo returned to Stardom Schools unexpectedly on the Monday after his planned departure.',
    full: 'In the novel\'s climactic and most celebrated moment, Bepo returns to Stardom Schools on the Monday after his supposed departure to the UK. Students and staff are surprised and overwhelmed with joy. His return — after the emotional farewell, the cultural performances, the gifts, and all the preparations — proves that his heart was always with Stardom. The moment is both a personal triumph and the novel\'s central statement about duty, love, and patriotism over the lure of migration.',
    h: 'What was the surprising event that occurred the Monday after Bepo\'s farewell?',
  },
  {
    yr: 2025,
    q: 'What did the students chant when Bepo returned to Stardom Schools?',
    o: [
      '"We\'re Stars, we\'re always winning!"',
      '"Welcome back, Principal!"',
      '"Thank you, Bepo!"',
      '"Our heart is here!"',
    ],
    a: 0,
    e: 'The students chanted "We\'re Stars, we\'re always winning!" — Stardom\'s victory song — when Bepo returned.',
    full: '"We\'re Stars, we\'re always winning!" is Stardom Schools\' victory song — a chant that represents the school\'s spirit, pride, and collective identity. When students saw Bepo return on that Monday morning, they broke into this chant spontaneously, expressing their joy, their unity, and their connection to the school\'s values. The choice of this particular chant is significant: Bepo\'s return itself is the "winning" — the triumph of mission over migration.',
    h: 'Which school chant did students sing to celebrate Bepo\'s return?',
  },
  {
    yr: 2025,
    q: 'Why did Bepo decide to return to Stardom Schools?',
    o: [
      'He missed his students and mission',
      'His flight was cancelled',
      'His passport was invalid',
      'He received a call from Mrs. Gloss',
    ],
    a: 0,
    e: 'Bepo returned because he missed his students and his mission — his emotional and purposeful connection to Stardom proved stronger than his desire to migrate.',
    full: 'Bepo\'s return to Stardom was not triggered by any external circumstance — his flight was not cancelled, his passport was not invalid, and he did not receive a call summoning him back. It was entirely an internal decision, driven by his deep love for his students, his mission to educate and culturally ground them, and his realisation — crystallised by the canoe dance and the airport dream — that his true place was at Stardom Schools in Nigeria. The decision represents the novel\'s core message about purpose and patriotism.',
    h: 'What internal motivation brought Bepo back to Stardom Schools?',
  },
  {
    yr: 2025,
    q: 'What symbolic significance did Bepo\'s return to Stardom Schools carry?',
    o: [
      'Dedication to his duty',
      'Nostalgia for Nigeria',
      'Rejection of migration',
      'Triumph of love over ambition',
    ],
    a: 0,
    e: 'Bepo\'s return primarily symbolises dedication to his duty — the choice of mission and responsibility over personal opportunity.',
    full: 'Bepo\'s return to Stardom Schools is the defining symbolic act of the entire novel. It demonstrates that true leadership and dedication to duty are not abandoned when personal opportunity calls. While his return is also driven by love for his students and his cultural roots, the deepest symbolic meaning is dedication to duty — the realisation that his 24-year mission at Stardom is his true calling, and no overseas opportunity can replace the fulfilment that comes from serving that mission.',
    h: 'What does Bepo\'s return to Stardom ultimately symbolise about character?',
  },
  {
    yr: 2025,
    q: 'What does the term "Japa syndrome" imply in "The Lekki Headmaster"?',
    o: [
      'Leaving Nigeria for greener pastures',
      'Escaping responsibilities',
      'Returning home after migration',
      'Celebrating cultural heritage',
    ],
    a: 0,
    e: '"Japa syndrome" in the novel means leaving Nigeria for greener pastures — emigrating in search of better opportunities abroad.',
    full: '"Japa" is Yoruba slang for running away or leaving quickly. In the context of contemporary Nigeria, it refers specifically to emigrating from Nigeria to countries like the UK, USA, Canada, or Australia in search of better living standards, salaries, and professional opportunities. The "syndrome" part implies that it has become epidemic — widespread and almost reflexive. The novel uses Bepo\'s story to explore and ultimately question whether "Japa" is always the right answer for talented, committed Nigerians.',
    h: 'What does "Japa syndrome" specifically refer to in Nigerian context and in the novel?',
  },
  {
    yr: 2025,
    q: 'What was Bepo\'s emotional reflection during his dream at the airport?',
    o: [
      'The history of slavery',
      'His personal struggle with leaving home',
      'His fears about his future abroad',
      'All of the above',
    ],
    a: 3,
    e: 'All three elements were present in Bepo\'s airport dream: reflections on slavery\'s history, his personal struggle with leaving home, and fears about his future abroad.',
    full: 'Bepo\'s dream at the airport is a rich, multi-layered psychological experience. It draws on the imagery of the slave museum and the Point of No Return (history of slavery), reflects his deep emotional ties to Nigeria and Stardom Schools (struggle with leaving home), and confronts his uncertainty about life abroad (fears about the future). All three dimensions combine to create a dream that functions as his subconscious mind\'s final plea for him to reconsider his departure.',
    h: 'What were all the emotional threads woven into Bepo\'s airport dream?',
  },
  {
    yr: 2025,
    q: 'What nickname did the students and staff use for Bepo?',
    o: ['"The Principal"', '"Headmaster Bepo"', '"Principoo"', '"Mr. Adebowale"'],
    a: 2,
    e: 'Bepo was affectionately nicknamed "Principoo" by students and staff at Stardom Schools.',
    full: '"Principoo" is the novel\'s title\'s direct reference — derived from "Principal" and Bepo\'s surname suffix "-po" (from Adebepo). It is a playful, affectionate corruption of "Principal" that the students use to express their fondness for Bepo. The nickname captures the warm, familial relationship between Bepo and his school community — he is not a distant authority figure but a beloved "Principoo."',
    h: 'What was the affectionate nickname students gave to Bepo at Stardom Schools?',
  },
  {
    yr: 2025,
    q: 'Why did Bepo develop a special bond with Jide, his landlord\'s grandson?',
    o: [
      'He coached him in elocution and African history',
      'Jide reminded him of his childhood',
      'Jide was the most disciplined child in the neighbourhood',
      'Jide often helped him with household chores',
    ],
    a: 0,
    e: 'Bepo bonded with Jide because he personally coached him in elocution and African history — extending his educational mission beyond the school.',
    full: 'Bepo\'s mentorship of Jide, his landlord\'s grandson, is one of the novel\'s touching sub-narratives. Bepo saw in Jide a young person hungry for knowledge and guidance, and he invested time in coaching him in elocution (public speaking) and African history. This relationship shows that Bepo\'s dedication to education was not confined to Stardom Schools — it was a personal calling that extended into his neighbourhood and everyday life.',
    h: 'What did Bepo teach his landlord\'s grandson Jide that created their special bond?',
  }];
